/* eslint-disable max-len */
/* eslint-disable prefer-spread */
/* eslint-disable @typescript-eslint/no-this-alias */
import {cellEditorConfigure} from './mxCellEditorConfigure';
import {EditorRegistryService} from '../editor/editor-registry.service';
import {ElementRef, Injectable} from '@angular/core';
import {TextEditingStylesService} from './text-editing-styles.service';
import {
  isActivity,
  isConnector,
  isFlowline,
  isImage,
  isInteraction,
  isLineText,
  isSticker,
  isTerminator,
  isText
} from '../../helpers/shapes-detectors.util';
import {StylesService} from '../../styles/styles.service';
import {AngularComponentService} from './angular-component.service';
import {FlowlineHelperService} from '../../helpers/flowline-helper.service';
import * as _ from 'lodash';
import {distinctUntilChanged, filter, skip, take} from 'rxjs/operators';
import DOMPurify from 'dompurify';
import {getFullName} from '@q9elements/ui-kit/common';

import {ActivityCommands} from '../../../commands/activity/activity.commands';
import {GraphHelperService} from '../../helpers/graph-helper.service';
import {UndoService} from '../../../commands/undo.service';
import {GraphModeService} from '../../../editor-state/graph-mode.service';
import {SidebarService} from '../../../editor-interface/sidebar/sidebar.service';
import {MxCellExtend} from './mxCell.extend';
import {TextCommands} from '../../../commands/text/text.commands';
import {StickerCommands} from '../../../commands/sticky-note/sticker.commands';
import {FlowlineCommands} from '../../../commands/flowline/flowline.commands';
import {GeneralCommands} from '../../../commands/general/general.commands';
import {DiagramJsonHandlerService} from '../../../diagram-data/diagram-json-handler.service';
import {NavigationService} from '../../../core/navigation/navigation.service';
import {GraphExportService} from '../../../diagram-interaction/services/graph-export.service';
import {MapService} from '../../../core/map/map.service';
import {MapTreeService} from '../../../core/services/map-tree.service';
import {CellsHighlighter} from '../../helpers/cells-highlighter';
import {StickersService} from '../../../diagram-interaction/services/stickers.service';
import {MxCell} from 'src/app/editor-interface/shared/models/mx-cell.interface';
import {initContextBarHandler} from './context-bar/mxContextBarHandler';
import {ContextBarService} from 'src/app/diagram-interaction/context-bar/context-bar.service';
import {DiagramTypeConfigService} from '../../../core/services/diagram-type-config.service';
import {extendMxConstraintHandler} from './mxConstraintHandler.extend';
import {extendLineJumps} from './mxLineJumps.extend';
import {PositionType} from '../../../diagram-render/styles/diagram-type-styles.model';

declare let mxClient: any;
declare let mxConstants: any;
declare let mxGraph: any;
declare let mxRubberband: any;
declare let mxRectangleShape: any;
declare let mxText: any;
declare let mxCellRenderer: any;
declare let mxPrintPreview: any;
declare let mxUtils: any;
declare let mxResources: any;
declare let mxShape: any;
declare let mxStencil: any;
declare let mxSelectionCellsHandler: any;
declare let mxVertexHandler: any;
declare let mxGraphHandler: any;
declare let mxCellEditor: any;
declare let mxTooltipHandler: any;
declare let mxConnectionHandler: any;
declare let mxGraphView: any;
declare let mxEvent: any;
declare let mxLayoutManager: any;
declare let mxStackLayout: any;
declare let mxHierarchicalLayout: any;
declare let mxCompactTreeLayout: any;
declare let mxPoint: any;
declare let mxCell: any;
declare let mxCellMarker: any;
declare let mxGeometry: any;
declare let mxConnectionConstraint: any;
declare let mxEventObject: any;
declare let mxPopupMenuHandler: any;
declare let mxConstraintHandler: any;
declare let mxImage: any;
declare let mxRectangle: any;
declare let mxGuide: any;
declare let mxPolyline: any;
declare let mxSvgCanvas2D: any;
declare let mxEdgeHandler: any;
declare let mxDictionary: any;
declare let mxOutline: any;
declare let mxCellHighlight: any;
declare let mxImageShape: any;
declare let Zlib: any; // still dont understand what it is

@Injectable()
export class Q9Graph {
  q9Graph;

  constructor(
    private registry: EditorRegistryService,
    private textEditStyleSvc: TextEditingStylesService,
    private compSvc: AngularComponentService,
    private styleSvc: StylesService,
    private flowlineHelperSvc: FlowlineHelperService,
    private activityCommands: ActivityCommands,
    private graphHelperSvc: GraphHelperService,
    private undoSvc: UndoService,
    private graphModeSvc: GraphModeService,
    private sidebarSvc: SidebarService,
    private textCommands: TextCommands,
    private stickerCommands: StickerCommands,
    private flowlineCommands: FlowlineCommands,
    private diagramJsonSvc: DiagramJsonHandlerService,
    private navSvc: NavigationService,
    private graphExportSvc: GraphExportService,
    private generalCommands: GeneralCommands,
    private mapService: MapService,
    private mapTreeSvc: MapTreeService,
    private stickersSvc: StickersService,
    private diagramTypeConfigSvc: DiagramTypeConfigService,
    private stylesSvc: StylesService,
    private contextBarSvc: ContextBarService,
    private mxCellExtend: MxCellExtend /** Do not delete **/
  ) {
    cellEditorConfigure();
    extendLineJumps();

    mxClient.NO_FO = true;

    this.mapService.isSFA$
      .pipe(
        filter(value => typeof value === 'boolean'),
        distinctUntilChanged(),
        skip(1),
        take(1)
      )
      .subscribe(() => {
        if (this.diagramTypeConfigSvc.isArchitecture()) {
          mxClient.NO_FO = false;
          this.mapTreeSvc.triggerUpdate();
        }
      });
    const IMAGE_PATH = 'images';
    const editorRegistry = this.registry;

    // Specifies if the touch UI should be used (cannot detect touch in FF so always on for Windows/Linux)
    const touchStyle =
      mxClient.IS_TOUCH ||
      (mxClient.IS_FF && mxClient.IS_WIN) ||
      navigator.maxTouchPoints > 0 ||
      // @ts-ignore
      navigator.msMaxTouchPoints > 0;

    // Makes the shadow brighter
    mxConstants.SHADOWCOLOR = '#d0d0d0';

    // Changes some default colors
    mxConstants.HANDLE_FILLCOLOR = '#99ccff';
    mxConstants.HANDLE_STROKECOLOR = '#0088cf';
    mxConstants.VERTEX_SELECTION_COLOR = '#00a8ff';
    mxConstants.OUTLINE_COLOR = '#00a8ff';
    mxConstants.OUTLINE_HANDLE_FILLCOLOR = '#99ccff';
    mxConstants.OUTLINE_HANDLE_STROKECOLOR = '#00a8ff';
    mxConstants.CONNECT_HANDLE_FILLCOLOR = '#cee7ff';
    mxConstants.EDGE_SELECTION_COLOR = '#00a8ff';
    mxConstants.DEFAULT_VALID_COLOR = '#00a8ff';
    mxConstants.LABEL_HANDLE_FILLCOLOR = '#cee7ff';
    mxConstants.GUIDE_COLOR = '#0088cf';
    //Make text labels visible
    mxConstants.STYLE_OVERFLOW = 'visible';
    mxConstants.STYLE_AUTOSIZE = 1;
    mxConstants.DEFAULT_INVALID_COLOR = 'transparent';

    //Make cells locked
    mxConstants.STYLE_LOCKED = 'locked';

    // Event of change including different types of edits which are not implemented in mxGraph by default
    mxEvent.CHANGE_COMMAND = 'CHANGE_COMMAND';

    // Event of handling context bar initialization / destroying not only on selection change
    mxEvent.HANDLE_CONTEXT_BAR = 'HANDLE_CONTEXT_BAR';

    // Util to write bounds of non-mxgraph elements added on the canvas
    mxUtils.writeElementBounds = function (name: string, elementRef: ElementRef) {
      const {offsetLeft, offsetTop, offsetWidth, offsetHeight} = elementRef.nativeElement;

      mxConstants[name] = {
        x: offsetLeft,
        y: offsetTop,
        width: offsetWidth,
        height: offsetHeight
      };
    };

    mxGraph.prototype.pageBreakColor = '#c0c0c0';
    mxGraph.prototype.pageScale = 1;
    mxGraph.prototype.pageVisible = true;

    mxGraph.prototype.adjustForVisibleToolbar = function (
      topToolbarHeight: number,
      leftToolbarWidth: number = 0
    ): void {
      requestAnimationFrame(() => {
        this.container.scrollTop -= topToolbarHeight;
        this.container.scrollLeft -= leftToolbarWidth;
      });
    };

    mxGraph.prototype.isGridEnabledEvent = function (evt) {
      return false;
    };

    // Turns off the force selection of elements even in view mode if ALT button pressed and allows selection over swimlanes
    mxRubberband.prototype.isForceRubberbandEvent = function (me) {
      let graph;

      if (me.state && me.state.cell) {
        graph = editorRegistry.getEditorUI().editor.graph;

        return graph.isEnabled() && graph.isSwimlane(me.state.cell);
      }

      return false;
    };

    const writeHead = mxPrintPreview.prototype.writeHead;

    mxPrintPreview.prototype.writeHead = function (doc, css) {
      writeHead.apply(this, arguments);

      const styleEl = document.createElement('style');

      styleEl.innerHTML = graphExportSvc.globalCss;
      doc.writeln(mxUtils.getOuterHtml(styleEl));
      const styles = document.getElementsByTagName('style');

      for (let j = 0; j < styles.length; j++) {
        doc.writeln(mxUtils.getOuterHtml(styles[j]));
      }
    };

    // Define connection points - 12 floating x's (point.gif) around perimeter

    mxRectangleShape.prototype.constraints = [
      {point: {x: 0.5, y: 1}, perimeter: 1},
      {point: {x: 0.5, y: 0}, perimeter: 1},
      {point: {x: 0, y: 0.5}, perimeter: 1},
      {point: {x: 1, y: 0.5}, perimeter: 1},
      {point: {x: 1, y: 0.25}, perimeter: 1},
      {point: {x: 1, y: 0.75}, perimeter: 1},
      {point: {x: 0, y: 0.25}, perimeter: 1},
      {point: {x: 0, y: 0.75}, perimeter: 1},
      {point: {x: 0.25, y: 0}, perimeter: 1},
      {point: {x: 0.75, y: 0}, perimeter: 1},
      {point: {x: 0.25, y: 1}, perimeter: 1},
      {point: {x: 0.75, y: 1}, perimeter: 1}
    ];

    // Matches label positions of mxGraph 1.x
    mxText.prototype.baseSpacingTop = 5;
    mxText.prototype.baseSpacingBottom = 1;

    /**
     * This function puts current text selection to the $rootScope, so it is possible then to restore it and apply changes
     * even if selection was lost
     * */
    function _saveCurrentSelection() {
      if (window.getSelection) {
        const sel = window.getSelection();

        if (sel.getRangeAt && sel.rangeCount) {
          sidebarSvc.savedTextSel = sel.getRangeAt(0);

          return;
        }
      }

      // old DE
      //  else if ($document[0].selection && $document[0].selection.createRange) {
      //   $rootScope.savedTextSel = $document[0].selection.createRange();
      //   return
      // }
      // else if (document.getSelection() && document.getSelection().createRange) {
      //   sidebarSvc.savedTextSel = document.getSelection().createRange();
      //   return;
      // }
      sidebarSvc.savedTextSel = null;
    }

    /**
     * Adds custom stencils defined via shape=stencil(value) style. The value is a base64 encoded, compressed and
     * URL encoded XML definition of the shape according to the stencil definition language of mxGraph.
     */

    const mxCellRendererInitializeShape = mxCellRenderer.prototype.initializeShape;

    mxCellRenderer.prototype.initializeShape = function (state) {
      mxCellRendererInitializeShape.apply(this, arguments);

      if (state.shape.node != null && state.cell.id != null) {
        state.shape.node.setAttribute('id', 'shape-' + state.cell.id);
      }
    };

    mxGraph.prototype.getEdgeValidationError = function (edge, source, target) {
      if (edge != null && !this.isAllowDanglingEdges() && (source == null || target == null)) {
        return '';
      }

      // Checks if we're dealing with a loop
      if (!this.allowLoops && source == target && source != null) {
        return '';
      }

      // Checks if the connection is generally allowed
      if (!this.isValidConnection(source, target)) {
        return '';
      }

      if (source && !target) {
        if (isConnector(source) || isTerminator(source)) {
          if (!edge) {
            return 'error';
          }

          return source.edges[0].id !== edge.id
            ? 'Cant connect more then 2 edges to connecctor/terminator'
            : '';
        }
      }

      if (!source && target) {
        if (isConnector(target) || isTerminator(target)) {
          if (!edge) {
            return 'error';
          }

          return target.edges[0].id !== edge.id
            ? 'Cant connect more then 2 edges to connecctor/terminator'
            : '';
        }
      }

      if (source != null && target != null) {
        let error = '';

        // Checks if the cells are already connected
        // and adds an error message if required
        if (!this.multigraph) {
          const tmp = this.model.getEdgesBetween(source, target, true);

          // Checks if the source and target are not connected by another edge
          if (tmp.length > 1 || (tmp.length == 1 && tmp[0] != edge)) {
            error +=
              (mxResources.get(this.alreadyConnectedResource) || this.alreadyConnectedResource) +
              '\n';
          }
        }

        // Gets the number of outgoing edges from the source
        // and the number of incoming edges from the target
        // without counting the edge being currently changed.
        const sourceOut = this.model.getDirectedEdgeCount(source, true, edge);
        const targetIn = this.model.getDirectedEdgeCount(target, false, edge);

        // Checks the change against each multiplicity rule
        if (this.multiplicities != null) {
          for (let i = 0; i < this.multiplicities.length; i++) {
            const err = this.multiplicities[i].check(
              this,
              edge,
              source,
              target,
              sourceOut,
              targetIn
            );

            if (err != null) {
              error += err;
            }
          }
        }

        // Validates the source and target terminals independently
        const err = this.validateEdge(edge, source, target);

        if (err != null) {
          error += err;
        }

        return error.length > 0 ? error : null;
      }

      return this.allowDanglingEdges ? null : '';
    };

    mxGraph.prototype.validationAlert = function (message) {};

    mxGraph.prototype.selectActivities = function () {
      const defaultParent = this.getDefaultParent();
      const isActivity = mxUtils.bind(this, function (cell: MxCell) {
        return cell && cell.isVertex() && cell.div && cell.div.tagName === 'APP-ACTIVITY-SHAPE';
      });
      const activities = this.model.filterDescendants(isActivity, defaultParent);

      this.setSelectionCells(activities);
    };

    mxGraph.prototype.isValidSource = function (cell) {
      return (
        (cell == null && this.allowDanglingEdges) ||
        (cell != null && (!this.model.isEdge(cell) || this.connectableEdges))
      );
    };

    mxGraph.prototype.isValidTarget = function (cell) {
      return this.isValidSource(cell);
    };

    mxGraph.prototype.isValidConnection = function (source, target) {
      if (
        isText(source) ||
        isText(target) ||
        isSticker(target) ||
        isSticker(source) ||
        isImage(target) ||
        isImage(source)
      ) {
        return false;
      }

      if (this.isSwimlane(source) || this.isSwimlane(target)) {
        return false;
      }

      return this.isValidSource(source) && this.isValidTarget(target);
    };

    /**
     * Function: clear
     *
     * Removes all child nodes and resets all CSS.
     */
    mxShape.prototype.clear = function () {
      if (this.node.ownerSVGElement != null) {
        while (this.node.lastChild != null) {
          this.node.removeChild(this.node.lastChild);
        }
      } else {
        this.node.style.cssText =
          'position:absolute;' + (this.cursor != null ? 'cursor:' + this.cursor + ';' : '');
      }
    };

    /**
     * Function: updateValue
     *
     * Updates the HTML node(s) to reflect the latest bounds and scale.
     */
    mxText.prototype.updateValue = function () {
      if (mxUtils.isNode(this.value)) {
        this.node.appendChild(this.value);
      } else {
        let val = this.value;

        if (this.dialect != mxConstants.DIALECT_STRICTHTML) {
          val = mxUtils.htmlEntities(val, false);
        }

        val = this.replaceLinefeeds ? val.replace(/\n/g, '<br/>') : val;
        const bg =
          this.background != null && this.background != mxConstants.NONE ? this.background : null;
        const bd = this.border != null && this.border != mxConstants.NONE ? this.border : null;

        if (this.overflow == 'fill' || this.overflow == 'width') {
          if (bg != null) {
            this.node.style.backgroundColor = bg;
          }

          if (bd != null) {
            this.node.style.border = '1px solid ' + bd;
          }
        } else {
          let css = '';

          if (bg != null) {
            css += 'background-color:' + bg + ';';
          }

          if (bd != null) {
            css += 'border:1px solid ' + bd + ';';
          }

          // Wrapper DIV for background, zoom needed for inline in quirks
          // and to measure wrapped font sizes in all browsers
          // FIXME: Background size in quirks mode for wrapped text
          const lh = mxConstants.ABSOLUTE_LINE_HEIGHT
            ? Math.round(this.size * mxConstants.LINE_HEIGHT) + 'px'
            : mxConstants.LINE_HEIGHT;

          val =
            '<div style="zoom:1;' +
            css +
            'display:inline-block;text-decoration:inherit;' +
            'padding-bottom:1px;padding-right:1px;line-height:' +
            lh +
            '">' +
            val +
            '</div>';
        }

        this.node.innerHTML = val;

        // Sets text direction
        const divs = this.node.getElementsByTagName('div');

        if (divs.length > 0) {
          let dir = this.textDirection;

          if (
            dir == mxConstants.TEXT_DIRECTION_AUTO &&
            this.dialect != mxConstants.DIALECT_STRICTHTML
          ) {
            dir = this.getAutoDirection();
          }

          if (dir == mxConstants.TEXT_DIRECTION_LTR || dir == mxConstants.TEXT_DIRECTION_RTL) {
            divs[divs.length - 1].setAttribute('dir', dir);
          } else {
            divs[divs.length - 1].removeAttribute('dir');
          }
        }
      }
    };

    mxGraph.prototype.isCellSelectable = function (cell) {
      const state = this.view.getState(cell);
      const style = state != null ? state.style : this.getCellStyle(cell);

      return this.isCellsSelectable() && style['selectable'] != 0;
    };

    mxGraph.prototype.validateEdge = function (edge, source, target) {
      if (isText(source) || isText(target)) {
        return 'Source and target should be text';
      }

      if (isTerminator(source) && isTerminator(target)) {
        return 'Source and target cant be terminators';
      }

      if (isConnector(source) && isConnector(target)) {
        return 'Source and target cant be connectors';
      }

      if (
        (isConnector(source) && isTerminator(target)) ||
        (isTerminator(source) && isConnector(target))
      ) {
        return "Connector and terminator can't be connected";
      }

      if (isConnector(source) || isTerminator(source)) {
        if (!edge) {
          return 'error';
        }

        return source.edges[0].id !== edge.id
          ? 'Cant connect more then 2 edges to connecctor/terminator'
          : null;
      }

      if (isConnector(target) || isTerminator(target)) {
        if (!edge) {
          return 'error';
        }

        return target.edges[0].id !== edge.id
          ? 'Cant connect more then 2 edges to connecctor/terminator'
          : null;
      }

      return null;
    };

    mxCellRenderer.prototype.destroy = function (state) {
      if (state.shape != null) {
        if (state.text != null) {
          state.text.destroy();
          state.text = null;
        }

        if (state.overlays != null) {
          state.overlays.visit(function (id, shape) {
            shape.destroy();
          });

          state.overlays = null;
        }

        if (state.control != null) {
          state.control.destroy();
          state.control = null;
        }

        state.shape.destroy();
        state.shape = null;
      }
    };

    mxGraph.prototype.createTooltipHandler = function () {
      return new mxTooltipHandler(this, 350);
    };

    /**
     * Function: redrawHtmlShape
     *
     * Updates the HTML node(s) to reflect the latest bounds and scale.
     */
    const mxTextRedrawProto = mxText.prototype.redraw;

    mxText.prototype.redraw = function () {
      mxTextRedrawProto.apply(this, arguments);

      if (isFlowline(this.state.cell) && diagramTypeConfigSvc.isArchitecture()) {
        const div = this.node?.querySelector('div');

        if (div) {
          const style = this.state.style;

          div.style.display = div.textContent.length > 0 ? 'inline-block' : 'none';
          div.style.padding = '5px 15px';
          div.style.borderRadius = '50vh';
          div.style.backgroundColor = 'white';
          div.style.borderStyle = style.dashed
            ? style.dashPattern
              ? 'dotted'
              : 'dashed'
            : 'solid';
          div.style.borderColor = style.strokeColor;
          div.style.borderWidth = style.strokeWidth + 'px';
          div.style.marginTop = -style.strokeWidth + 'px';
          div.style.marginLeft = -style.strokeWidth + 'px';
        }
      }

      if (isActivity(this.state.cell)) {
        this.node.style.overflow = 'visible';

        if (!mxClient.NO_FO) {
          const divs = this.node.getElementsByTagName('div');

          divs[0].style.overflow = 'visible';
        }
      }

      if (isSticker(this.state.cell)) {
        this.node.style.overflow = 'visible';

        if (mxClient.NO_FO) {
          this.node.className = this.state.style.paperClass || 'yellow-paper-gold';
        } else {
          const divs = this.node.getElementsByTagName('div');

          divs[0].style.overflow = 'visible';
          divs[0].className = this.state.style.paperClass || 'yellow-paper-gold';
        }
      }
    };

    /**
     * Defines graph class.
     */
    const Graph = function (container, model, renderHint, stylesheet) {
      mxGraph.call(this, container, model, renderHint, stylesheet);

      this.isHtmlLabel = function (cell) {
        const state = this.view.getState(cell);
        const style = state != null ? state.style : this.getCellStyle(cell);

        return style['html'] == '1' || style[mxConstants.STYLE_WHITE_SPACE] == 'wrap';
      };

      // HTML entities are displayed as plain text in wrapped plain text labels
      this.cellRenderer.getLabelValue = function (state) {
        let result = mxCellRenderer.prototype.getLabelValue.apply(this, arguments);

        if (state.view.graph.isHtmlLabel(state.cell)) {
          if (state.style['html'] != 1) {
            result = mxUtils.htmlEntities(result, false);
          } else {
            result = state.view.graph.sanitizeHtml(result);
          }
        }

        return result;
      };

      if (typeof mxVertexHandler !== 'undefined') {
        this.setConnectable(true);
        this.setDropEnabled(true);
        this.setPanning(true);
        this.setTooltips(true);
        this.setAllowLoops(true);
        this.allowAutoPanning = true;
        this.resetEdgesOnConnect = false;
        this.constrainChildren = false;

        this.graphHandler.scrollOnMove = false;
        this.graphHandler.scaleGrid = true;

        this.connectionHandler.setCreateTarget(false);

        this.connectionHandler.isValidSource = function (cell, me) {
          return false;
        };

        // Sets the style to be used when an elbow edge is double clicked
        this.alternateEdgeStyle = 'vertical';

        if (stylesheet == null) {
          const edgeStyle = this.getStylesheet();

          edgeStyle.styles.defaultEdge = styleSvc.flowline().mxCellCssAsObject();
        }

        // Changes color of move preview for black backgrounds
        this.graphHandler.createPreviewShape = function (bounds) {
          this.previewColor =
            this.graph.background == '#000000'
              ? 'var(--q9-surface-100)'
              : mxGraphHandler.prototype.previewColor;

          return mxGraphHandler.prototype.createPreviewShape.apply(this, arguments);
        };

        this.isCellsMovable = function () {
          return this.cellsMovable;
        };

        mxGraph.prototype.selectAll = function (parent) {
          const selectElements = graphHelperSvc.all();

          if (selectElements.length) {
            this.setSelectionCells(selectElements);
          }
        };

        mxCellEditor.prototype.getInitialValue = function (state, trigger) {
          const cell = state.cell;
          const value = this.graph.getEditingValue(state.cell, trigger);

          cell.editingValue = cell.value;
          cell.value = '';

          return value;
        };

        this.getEditingValue = function (cell, evt) {
          const html = cell.value;

          if (evt?.specialTarget) {
            return evt.specialTarget.innerHTML;
          }

          if (
            cell.edge ||
            isLineText(cell) ||
            isActivity(cell) ||
            isText(cell) ||
            isImage(cell) ||
            isSticker(cell)
          ) {
            const indexOfBeginMarker = html.indexOf('<!--contentbegin-->');
            const indexOfEndMarker = html.indexOf('<!--contentend-->');

            this.editingPrefix = html.slice(0, indexOfBeginMarker);
            this.editingSuffix = html.slice(indexOfEndMarker + 17, html.length);
            delete cell.oldValue;
            cell.editing = true;

            // Workaround for regression that shows the old content behind the transparent editor
            return html.slice(indexOfBeginMarker + 19, indexOfEndMarker);
          }

          this.editingSuffix = this.editingPrefix = '';

          return html;
        };

        // Handles parts of cells by checking if part=1 is in the style and returning the parent
        // LATER: Handle recursive parts
        this.graphHandler.getCells = function (initialCell) {
          const cells = mxGraphHandler.prototype.getCells.apply(this, arguments);

          for (let i = 0; i < cells.length; i++) {
            const state = this.graph.view.getState(cells[i]);
            const style = state != null ? state.style : this.graph.getCellStyle(cells[i]);

            if (mxUtils.getValue(style, 'part', '0') == '1') {
              const parent = this.graph.model.getParent(cells[i]);

              if (this.graph.model.isVertex(parent)) {
                cells[i] = parent;
              }
            }
          }

          return cells;
        };

        // Handles parts of cells when cloning the source for new connections
        this.connectionHandler.createTargetVertex = function (evt, source) {
          const state = this.graph.view.getState(source);
          const style = state != null ? state.style : this.graph.getCellStyle(source);

          if (mxUtils.getValue(style, 'part', false)) {
            const parent = this.graph.model.getParent(source);

            if (this.graph.model.isVertex(parent)) {
              source = parent;
            }
          }

          return mxConnectionHandler.prototype.createTargetVertex.apply(this, arguments);
        };

        const rubberband = new mxRubberband(this);

        this.getRubberband = function () {
          return rubberband;
        };

        // Timer-based activation of outline connect in connection handler
        let startTime = new Date().getTime();
        let timeOnTarget = 0;

        const connectionHandlerMouseMove = this.connectionHandler.mouseMove;

        this.connectionHandler.mouseMove = function () {
          const prev = this.currentState;

          connectionHandlerMouseMove.apply(this, arguments);

          if (prev != this.currentState) {
            startTime = new Date().getTime();
            timeOnTarget = 0;
          } else {
            timeOnTarget = new Date().getTime() - startTime;
          }
        };

        this.connectionHandler.isOutlineConnectEvent = function (me) {
          return true;
        };

        // Workaround for Firefox where first mouse down is received
        // after tap and hold if scrollbars are visible, which means
        // start rubberband immediately if no cell is under mouse.
        const isForceRubberBandEvent = rubberband.isForceRubberbandEvent;

        rubberband.isForceRubberbandEvent = function (me) {
          return (
            isForceRubberBandEvent.apply(this, arguments) ||
            (mxUtils.hasScrollbars(this.graph.container) &&
              mxClient.IS_FF &&
              mxClient.IS_WIN &&
              me.getState() == null &&
              mxEvent.isTouchEvent(me.getEvent()))
          );
        };

        // Shows hand cursor while panning
        this.panningHandler.addListener(
          mxEvent.PAN_START,
          mxUtils.bind(this, function () {
            this.container.style.cursor = 'move';
          })
        );

        this.panningHandler.addListener(
          mxEvent.PAN_END,
          mxUtils.bind(this, function () {
            this.container.style.cursor = 'default';
          })
        );

        // Forces panning for middle and right mouse buttons
        const panningHandlerIsForcePanningEvent = this.panningHandler.isForcePanningEvent;

        this.panningHandler.isForcePanningEvent = function (me) {
          return (
            panningHandlerIsForcePanningEvent.apply(this, arguments) ||
            (mxEvent.isMouseEvent(me.getEvent()) &&
              (mxEvent.isRightMouseButton(me.getEvent()) ||
                mxEvent.isMiddleMouseButton(me.getEvent())))
          );
        };

        this.popupMenuHandler.autoExpand = true;

        this.popupMenuHandler.isSelectOnPopup = function (me) {
          return mxEvent.isMouseEvent(me.getEvent());
        };

        this.linesHighlighter = new CellsHighlighter(this);

        // Enables links if graph is "disabled" (ie. read-only)
        const click = this.click;

        this.click = function (me) {
          // helper log
          if (me && me.state) {
            console.log(me.state);

            if (!window['graph']) {
              window['graph'] = this;
            }
          }

          const cell = me.getCell();
          const evt = me.getEvent();

          if (cell && (isFlowline(cell) || isLineText(cell) || isInteraction(cell))) {
            const edge = isFlowline(cell) ? cell : cell.parent;
            const toHL = [edge, ...(edge.children || [])].filter(c => c !== cell);

            this.linesHighlighter.highlightWithTimeout(toHL);
          }

          if (!this.isEnabled()) {
            // previously here was the logic for selection mechanism in view mode
          } else {
            return click.apply(this, arguments);
          }
        };

        // Shows pointer cursor for clickable cells with links
        // ie. if the graph is disabled and cells cannot be selected
        const getCursorForCell = this.getCursorForCell;

        this.getCursorForCell = function (cell) {
          if (!this.isEnabled()) {
            if (isSticker(cell) && stickersSvc.canForceEdit(cell)) {
              return 'move';
            }

            if (isActivity(cell)) {
              return 'pointer';
            }

            let target;

            if (isImage(cell)) {
              target = _.find(diagramJsonSvc.get().images, {mxKey: +cell.id});
            }

            if (isText(cell)) {
              target = _.find(diagramJsonSvc.get().texts, {mxKey: +cell.id});
            }

            if ((target || {}).link) {
              return 'pointer';
            }
          } else if (this.isSwimlane(cell)) {
            return 'default';
          } else {
            return getCursorForCell.apply(this, arguments);
          }
        };

        // Changes rubberband selection to be recursive
        this.selectRegion = function (rect, evt) {
          const cells = this.getAllCells(rect.x, rect.y, rect.width, rect.height);

          this.selectCellsForEvent(cells, evt);

          return cells;
        };

        // Recursive implementation for rubberband selection
        this.getAllCells = function (x, y, width, height, parent, result) {
          result = result != null ? result : [];

          if (width > 0 || height > 0) {
            const model = this.getModel();
            const right = x + width;
            const bottom = y + height;

            if (parent == null) {
              parent = this.getCurrentRoot();

              if (parent == null) {
                parent = model.getRoot();
              }
            }

            if (parent != null) {
              const childCount = model.getChildCount(parent);

              for (let i = 0; i < childCount; i++) {
                const cell = model.getChildAt(parent, i);
                const state = this.view.getState(cell);

                if (state != null && this.isCellVisible(cell)) {
                  const deg = mxUtils.getValue(state.style, mxConstants.STYLE_ROTATION) || 0;
                  let box = state;

                  if (deg != 0) {
                    box = mxUtils.getBoundingBox(box, deg);
                  }

                  if (
                    (model.isEdge(cell) || model.isVertex(cell)) &&
                    box.x >= x &&
                    box.y + box.height <= bottom &&
                    box.y >= y &&
                    box.x + box.width <= right
                  ) {
                    result.push(cell);
                  }

                  this.getAllCells(x, y, width, height, cell, result);
                }
              }
            }
          }

          return result;
        };

        // Never removes cells from parents that are being moved
        const graphHandlerShouldRemoveCellsFromParent =
          this.graphHandler.shouldRemoveCellsFromParent;

        this.graphHandler.shouldRemoveCellsFromParent = function (parent, cells, evt) {
          if (this.graph.isCellSelected(parent)) {
            return false;
          }

          return graphHandlerShouldRemoveCellsFromParent.apply(this, arguments);
        };

        // Splitting edges is disabled
        this.setSplitEnabled(false);

        // checks if cell is locked
        this.isCellLocked = function (cell) {
          const result = Boolean(this.cellsLocked);
          const state = this.view.getState(cell);
          const style = state != null ? state.style : this.getCellStyle(cell);

          return result || !!+mxUtils.getValue(style, mxConstants.STYLE_LOCKED, '0');
        };

        // On connect the target is selected and we clone the cell of the preview edge for insert
        this.connectionHandler.selectCells = function (edge, target) {
          this.graph.setSelectionCell(target || edge);
        };

        // Shows connection points only if cell not selected
        this.connectionHandler.constraintHandler.isStateIgnored = function (state, source) {
          return source && state.view.graph.isCellSelected(state.cell);
        };

        // Updates constraint handler if the selection changes
        this.selectionModel.addListener(
          mxEvent.CHANGE,
          mxUtils.bind(this, function () {
            const ch = this.connectionHandler.constraintHandler;

            if (ch.currentFocus != null && ch.isStateIgnored(ch.currentFocus, true)) {
              ch.currentFocus = null;
              ch.constraints = null;
              ch.destroyIcons();
            }

            ch.destroyFocusHighlight();
          })
        );

        // Initializes touch interface
        if (touchStyle) {
          this.initTouch();
        }

        extendMxConstraintHandler.apply(this.connectionHandler.constraintHandler);
      }

      initContextBarHandler.apply(this, [compSvc, contextBarSvc]);
    };

    // Graph inherits from mxGraph
    mxUtils.extend(Graph, mxGraph);

    /**
     * Allows to all values in fit.
     */
    Graph.prototype.minFitScale = null;

    /**
     * Allows to all values in fit.
     */
    Graph.prototype.maxFitScale = null;

    /**
     * Sets the default target for all links in cells.
     */
    Graph.prototype.linkTarget = '_blank';

    Graph.prototype.isCellMovable = function (cell) {
      const state = this.view.getState(cell);
      const style = state != null ? state.style : this.getCellStyle(cell);
      let result;

      if (cell.edge) {
        result = !(cell.target || cell.source);
      } else {
        result =
          this.isCellsMovable() &&
          !this.isCellLocked(cell) &&
          style[mxConstants.STYLE_MOVABLE] != 0;
      }

      return result;
    };

    Graph.prototype.isLabelMovable = function (cell) {
      return (
        !this.isCellLocked(cell) &&
        ((this.model.isEdge(cell) &&
          this.edgeLabelsMovable &&
          diagramTypeConfigSvc.generalSettings().isLabelMovable) ||
          (this.model.isVertex(cell) && this.vertexLabelsMovable))
      );
    };

    Graph.prototype.isCellDisconnectable = function (cell, terminal, source) {
      let result = this.isCellsDisconnectable() && !this.isCellLocked(cell);

      if (cell.edge) {
        if (isTerminator(terminal) || isConnector(terminal)) {
          result = false;
        }
      }

      return result;
    };

    /**
     * Installs child layout styles.
     */
    Graph.prototype.init = function () {
      mxGraph.prototype.init.apply(this, arguments);

      /**
       * Disable move due to some condition
       * Mainly used to reorder resources
       * @type {Function}
       */
      const checkMove = function (sender, evt) {
        let condition;

        if (evt.state && evt.state.cell) {
          condition = sender.isSwimlane(evt.state.cell);
          sender.graphHandler.moveEnabled = !condition;
        }
      };

      const mouseListeners = {
        mouseDown: function (sender, evt) {},
        mouseUp: function (sender, evt) {},
        mouseMove: function (sender, evt) {
          checkMove(sender, evt);
        }
      };

      this.addMouseListener(mouseListeners);

      this.layoutManager = new mxLayoutManager(this);

      this.layoutManager.getLayout = function (cell) {
        const state = this.graph.view.getState(cell);
        const style = state != null ? state.style : this.graph.getCellStyle(cell);

        if (style['childLayout'] == 'stackLayout') {
          const stackLayout = new mxStackLayout(this.graph);

          stackLayout.resizeParentMax = true;
          stackLayout.resizeParent = mxUtils.getValue(style, 'resizeParent', '1') == '1';
          stackLayout.resizeLast = mxUtils.getValue(style, 'resizeLast', '0') == '1';
          stackLayout.marginLeft = style['marginLeft'] || 0;
          stackLayout.marginRight = style['marginRight'] || 0;
          stackLayout.marginTop = style['marginTop'] || 0;
          stackLayout.marginBottom = style['marginBottom'] || 0;
          stackLayout.x0 = style['startX'] || 0;
          stackLayout.y0 = style['startY'] || 0;
          stackLayout.horizontal = style['horizontalStack'];

          return stackLayout;
        } else if (style['childLayout'] == 'treeLayout') {
          const treeLayout = new mxCompactTreeLayout(this.graph);

          treeLayout.horizontal = mxUtils.getValue(style, 'horizontalTree', '1') == '1';
          treeLayout.resizeParent = mxUtils.getValue(style, 'resizeParent', '1') == '1';
          treeLayout.groupPadding = mxUtils.getValue(style, 'parentPadding', 20);
          treeLayout.levelDistance = mxUtils.getValue(style, 'treeLevelDistance', 30);
          treeLayout.maintainParentLocation = true;
          treeLayout.edgeRouting = false;
          treeLayout.resetEdges = false;

          return treeLayout;
        } else if (style['childLayout'] == 'flowLayout') {
          const flowLayout = new mxHierarchicalLayout(
            this.graph,
            mxUtils.getValue(style, 'flowOrientation', mxConstants.DIRECTION_EAST)
          );

          flowLayout.resizeParent = mxUtils.getValue(style, 'resizeParent', '1') == '1';
          flowLayout.parentBorder = mxUtils.getValue(style, 'parentPadding', 20);
          flowLayout.maintainParentLocation = true;

          // Special undocumented styles for changing the hierarchical
          flowLayout.intraCellSpacing = mxUtils.getValue(
            style,
            'intraCellSpacing',
            mxHierarchicalLayout.prototype.intraCellSpacing
          );
          flowLayout.interRankCellSpacing = mxUtils.getValue(
            style,
            'interRankCellSpacing',
            mxHierarchicalLayout.prototype.interRankCellSpacing
          );
          flowLayout.interHierarchySpacing = mxUtils.getValue(
            style,
            'interHierarchySpacing',
            mxHierarchicalLayout.prototype.interHierarchySpacing
          );
          flowLayout.parallelEdgeSpacing = mxUtils.getValue(
            style,
            'parallelEdgeSpacing',
            mxHierarchicalLayout.prototype.parallelEdgeSpacing
          );

          return flowLayout;
        }

        return null;
      };
    };

    /**
     * Sanitizes the given HTML markup.
     */
    Graph.prototype.sanitizeHtml = function (value) {
      // Uses https://code.google.com/p/google-caja/wiki/JsHtmlSanitizer
      // TODO: Add MathML to whitelisted tags
      function urlX(url) {
        if (/^https?:\/\//.test(url)) {
          return url;
        }
      }

      function idX(id) {
        return id;
      }

      //return html_sanitize(value, urlX, idX);
      return value;
    };

    /**
     * Returns the label for the given cell.
     */
    Graph.prototype.convertValueToString = function (cell) {
      if (cell.div != null) {
        return cell.div;
      }

      return mxGraph.prototype.convertValueToString.apply(this, arguments);
    };

    /**
     * Returns the link for the given cell.
     */
    Graph.prototype.getLinkForCell = function (cell) {
      if (cell.value != null && typeof cell.value == 'object') {
        return cell.value.getAttribute('link');
      }

      return null;
    };

    /**
     * Overrides label orientation for collapsed swimlanes inside stack.
     */
    Graph.prototype.getCellStyle = function (cell) {
      const style = mxGraph.prototype.getCellStyle.apply(this, arguments);

      if (cell != null && this.layoutManager != null) {
        const parent = this.model.getParent(cell);

        if (this.model.isVertex(parent) && this.isCellCollapsed(cell)) {
          const layout = this.layoutManager.getLayout(parent);

          if (layout != null && layout.constructor == mxStackLayout) {
            style[mxConstants.STYLE_HORIZONTAL] = !layout.horizontal;
          }
        }
      }

      return style;
    };

    /**
     * Disables alternate width persistence for stack layout parents
     */
    Graph.prototype.updateAlternateBounds = function (cell, geo, willCollapse) {
      if (
        cell != null &&
        geo != null &&
        this.layoutManager != null &&
        geo.alternateBounds != null
      ) {
        const layout = this.layoutManager.getLayout(this.model.getParent(cell));

        if (layout != null && layout.constructor == mxStackLayout) {
          if (layout.horizontal) {
            geo.alternateBounds.height = 0;
          } else {
            geo.alternateBounds.width = 0;
          }
        }
      }

      mxGraph.prototype.updateAlternateBounds.apply(this, arguments);
    };

    /**
     * Overrides label orientation for collapsed swimlanes inside stack.
     */
    Graph.prototype.moveSiblings = function (state, parent, dx, dy) {
      this.model.beginUpdate();

      try {
        const cells = this.getCellsBeyond(state.x, state.y, parent, true, true);

        for (let i = 0; i < cells.length; i++) {
          if (cells[i] != state.cell) {
            const tmp = this.view.getState(cells[i]);
            let geo = this.getCellGeometry(cells[i]);

            if (tmp != null && geo != null) {
              geo = geo.clone();
              geo.translate(
                Math.round(dx * Math.max(0, Math.min(1, (tmp.x - state.x) / state.width))),
                Math.round(dy * Math.max(0, Math.min(1, (tmp.y - state.y) / state.height)))
              );
              this.model.setGeometry(cells[i], geo);
            }
          }
        }
      } finally {
        this.model.endUpdate();
      }
    };

    /**
     * Overrides label orientation for collapsed swimlanes inside stack.
     */
    Graph.prototype.resizeParentStacks = function (parent, layout, dx, dy) {
      if (
        this.layoutManager != null &&
        layout != null &&
        layout.constructor == mxStackLayout &&
        !layout.resizeLast
      ) {
        this.model.beginUpdate();

        try {
          const dir = layout.horizontal;

          // Bubble resize up for all parent stack layouts with same orientation
          while (
            parent != null &&
            layout != null &&
            layout.constructor == mxStackLayout &&
            layout.horizontal == dir &&
            !layout.resizeLast
          ) {
            let pgeo = this.getCellGeometry(parent);
            const pstate = this.view.getState(parent);

            if (pstate != null && pgeo != null) {
              pgeo = pgeo.clone();

              if (layout.horizontal) {
                pgeo.width += dx + Math.min(0, pstate.width / this.view.scale - pgeo.width);
              } else {
                pgeo.height += dy + Math.min(0, pstate.height / this.view.scale - pgeo.height);
              }

              this.model.setGeometry(parent, pgeo);
            }

            parent = this.model.getParent(parent);
            layout = this.layoutManager.getLayout(parent);
          }
        } finally {
          this.model.endUpdate();
        }
      }
    };

    /**
     * @method isCellRotatable - Returns true or false depending on whether the given cell is rotatable
     * @param {object<mxCell>} cell
     * @returns {boolean}
     */
    Graph.prototype.isCellRotatable = function (cell) {
      const rotatable = mxGraph.prototype.isCellRotatable.apply(this, arguments);

      return rotatable && !this.isCellLocked(cell);
    };

    /**
     * Returns true if the given cell2 is inside of the bounds represented by the geometry of cell1
     */
    Graph.prototype.inGeoBounds = function (cell1, cell2) {
      const g1 = cell1.geometry;
      const g2 = cell2.geometry;
      const inWidth = g2.x >= g1.x && g2.x + g2.width <= g1.x + g1.width;
      const inHeight = g2.y >= g1.y && g2.y + g2.height <= g1.y + g1.height;

      return inWidth && inHeight;
    };

    Graph.prototype.getPagePadding = function () {
      return new mxPoint(0, 0);
    };

    // this is custom method to determine if user is currently moving any cell
    Graph.prototype.isDragging = function () {
      return Boolean(this.graphHandler.first);
    };

    Graph.prototype.isResizing = function () {
      const handlers = this.selectionCellsHandler?.handlers?.getValues?.() || [];

      return handlers.some(handler => handler.index != null);
    };

    Graph.prototype.isBusy = function () {
      return this.isEditing() || this.isDragging() || this.isResizing();
    };

    /**
     * Overrides method to provide connection constraints for shapes.
     */
    Graph.prototype.getAllConnectionConstraints = function (terminal, source) {
      if (terminal != null) {
        const constraints = mxUtils.getValue(terminal.style, 'points', null);

        if (constraints != null) {
          // Requires an array of arrays with x, y (0..1) and an optional
          // perimeter (0 or 1), eg. points=[[0,0,1],[0,1,0],[1,1]]
          const result = [];

          try {
            const c = JSON.parse(constraints);

            for (let i = 0; i < c.length; i++) {
              const tmp = c[i];

              result.push(
                new mxConnectionConstraint(
                  new mxPoint(tmp[0], tmp[1]),
                  tmp.length > 2 ? tmp[2] != '0' : true
                )
              );
            }
          } catch (e) {
            // ignore
          }

          return result;
        } else {
          if (terminal.shape != null) {
            if (terminal.shape.stencil != null) {
              if (terminal.shape.stencil != null) {
                return terminal.shape.stencil.constraints;
              }
            } else if (terminal.shape.constraints != null) {
              return terminal.shape.constraints;
            }
          }
        }
      }

      return null;
    };

    /**
     * Inverts the elbow edge style without removing existing styles.
     */
    Graph.prototype.flipEdge = function (edge) {
      if (edge != null) {
        const state = this.view.getState(edge);
        const style = state != null ? state.style : this.getCellStyle(edge);

        if (style != null) {
          const elbow = mxUtils.getValue(
            style,
            mxConstants.STYLE_ELBOW,
            mxConstants.ELBOW_HORIZONTAL
          );
          const value =
            elbow == mxConstants.ELBOW_HORIZONTAL
              ? mxConstants.ELBOW_VERTICAL
              : mxConstants.ELBOW_HORIZONTAL;

          this.setCellStyles(mxConstants.STYLE_ELBOW, value, [edge]);
        }
      }
    };

    /**
     * Overrides tooltips to show custom tooltip or metadata.
     */
    Graph.prototype.getTooltipForCell = function (cell) {
      let tip = '';

      if (isInteraction(cell)) {
        return cell.getJson()?.description || '';
      }

      if (isSticker(cell)) {
        const json = cell.getJson();
        const author = json.author ? getFullName(json.author) : 'unknown';
        const editor = json.editor ? getFullName(json.editor) : 'unknown';
        const dateDisplayConfig = {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        } as Intl.DateTimeFormatOptions;
        const createdDate = json.createdAt
          ? new Date(json.createdAt).toLocaleDateString('en-gb', dateDisplayConfig)
          : 'unknown date';
        const updatedDate = json.updatedAt
          ? new Date(json.updatedAt).toLocaleDateString('en-gb', dateDisplayConfig)
          : 'unknown date';

        tip = `Created by: ${author} on ${createdDate}
               Last edit: ${editor} on ${updatedDate}`;
      }

      if (mxUtils.isNode(cell.value)) {
        const tmp = cell.value.getAttribute('tooltip');

        if (tmp != null) {
          tip = this.sanitizeHtml(tmp);
        } else {
          const ignored = ['label', 'tooltip'];
          const attrs = cell.value.attributes;

          // Hides links in edit mode
          if (this.isEnabled()) {
            ignored.push('link');
          }

          for (let i = 0; i < attrs.length; i++) {
            if (mxUtils.indexOf(ignored, attrs[i].nodeName) < 0 && attrs[i].nodeValue.length > 0) {
              const key =
                attrs[i].nodeName.substring(0, 1).toUpperCase() + attrs[i].nodeName.substring(1);

              tip += key + ': ' + mxUtils.htmlEntities(attrs[i].nodeValue) + '\n';
            }
          }

          if (tip.length > 0) {
            tip = tip.substring(0, tip.length - 1);
          }
        }
      }

      return tip;
    };

    /**
     * Turns the given cells and returns the changed cells.
     */
    Graph.prototype.turnShapes = function (cells) {
      const model = this.getModel();
      const select = [];

      model.beginUpdate();

      try {
        for (let i = 0; i < cells.length; i++) {
          const cell = cells[i];

          if (model.isEdge(cell)) {
            const src = model.getTerminal(cell, true);
            const trg = model.getTerminal(cell, false);

            model.setTerminal(cell, trg, true);
            model.setTerminal(cell, src, false);

            let geo = model.getGeometry(cell);

            if (geo != null) {
              geo = geo.clone();

              if (geo.points != null) {
                geo.points.reverse();
              }

              const sp = geo.getTerminalPoint(true);
              const tp = geo.getTerminalPoint(false);

              geo.setTerminalPoint(sp, false);
              geo.setTerminalPoint(tp, true);
              model.setGeometry(cell, geo);

              // Inverts constraints
              const edgeState = this.view.getState(cell);
              const sourceState = this.view.getState(src);
              const targetState = this.view.getState(trg);

              if (edgeState != null) {
                const sc =
                  sourceState != null
                    ? this.getConnectionConstraint(edgeState, sourceState, true)
                    : null;
                const tc =
                  targetState != null
                    ? this.getConnectionConstraint(edgeState, targetState, false)
                    : null;

                this.setConnectionConstraint(cell, src, true, tc);
                this.setConnectionConstraint(cell, trg, false, sc);
              }

              select.push(cell);
            }
          } else if (model.isVertex(cell)) {
            let geo = this.getCellGeometry(cell);

            if (geo != null) {
              // Rotates the size and position in the geometry
              geo = geo.clone();
              geo.x += geo.width / 2 - geo.height / 2;
              geo.y += geo.height / 2 - geo.width / 2;
              const tmp = geo.width;

              geo.width = geo.height;
              geo.height = tmp;
              model.setGeometry(cell, geo);

              // Reads the current direction and advances by 90 degrees
              const state = this.view.getState(cell);

              if (state != null) {
                let dir = state.style[mxConstants.STYLE_DIRECTION] || 'east'; /*default*/

                if (dir == 'east') {
                  dir = 'south';
                } else if (dir == 'south') {
                  dir = 'west';
                } else if (dir == 'west') {
                  dir = 'north';
                } else if (dir == 'north') {
                  dir = 'east';
                }

                this.setCellStyles(mxConstants.STYLE_DIRECTION, dir, [cell]);
              }

              select.push(cell);
            }
          }
        }
      } finally {
        model.endUpdate();
      }

      return select;
    };

    Graph.prototype.getDropTarget = function (cells, evt, cell, clone) {
      // Remove "return null" in case you need to drop group into some special layer!
      return null;
    };

    /**
     * Overrides double click handling to add the tolerance and inserting text.
     */
    Graph.prototype.dblClick = function (evt, cell) {
      const shiftDown = mxEvent.isShiftDown(evt);
      const altDown = mxEvent.isAltDown(evt);
      const ctrlDown = this.isToggleEvent(evt);

      const pt = mxUtils.convertPoint(
        this.container,
        mxEvent.getClientX(evt),
        mxEvent.getClientY(evt)
      );
      const x = pt.x / this.view.scale - this.view.translate.x;
      const y = pt.y / this.view.scale - this.view.translate.y;

      // It is edge case when double-clicking on a swimlane and graph is in editing mode.
      if ((!cell || this.isSwimlane(cell)) && this.isEnabled() && this.isEditing()) {
        return;
      }

      const hasOverEmptySpace = !cell || this.isSwimlane(cell);

      if (hasOverEmptySpace && this.isEnabled()) {
        let createCommand;

        const {disableShortcutsForDbClick} = diagramTypeConfigSvc.generalSettings();

        if (!disableShortcutsForDbClick && shiftDown) {
          createCommand = stickerCommands.create(
            diagramTypeConfigSvc.stickerNoteSettings.preparePayload({
              x,
              y,
              mxKey: graphHelperSvc.getFreeNumber(7),
              position: PositionType.CENTER
            })
          );
        } else if (!disableShortcutsForDbClick && altDown) {
          const number = graphHelperSvc.getFreeNumber(4);

          const style = stylesSvc.getPrimary('text');
          const textData = diagramTypeConfigSvc.richTextSettings.preparePayload({
            x,
            y,
            number,
            style,
            position: PositionType.CENTER
          });

          createCommand = textCommands.create(textData);
        } else {
          switch (diagramTypeConfigSvc.generalSettings().canvasElementForDbClick) {
            case 'StickyNote':
              createCommand = stickerCommands.create(
                diagramTypeConfigSvc.stickerNoteSettings.preparePayload({
                  x,
                  y,
                  mxKey: graphHelperSvc.getFreeNumber(7),
                  position: PositionType.CENTER
                })
              );
              break;

            case 'Activity':

            default: {
              const number = graphHelperSvc.getFreeNumber(2);
              const {
                text,
                position,
                footerText,
                defaultResources,
                defaultAttributes,
                attributePadding
              } = diagramTypeConfigSvc.activitySettings(x, y);

              const activityData = {
                number,
                text,
                position,
                attributePadding,
                ...(footerText && {footerText}),
                ...(defaultResources && {resources: defaultResources}),
                ...(defaultAttributes && {attributes: defaultAttributes})
              };
              let flComm;

              createCommand =
                diagramTypeConfigSvc.isUPN() ||
                diagramTypeConfigSvc.activitySettings().createActivityWithFlowline
                  ? activityCommands
                      .create(activityData)
                      .chain((activityJson, activityCell) => {
                        this.model.beginUpdate();
                        flComm = flowlineCommands.create(
                          diagramTypeConfigSvc.flowlineSettings(
                            activityJson.position.x,
                            activityJson.position.y,
                            activityCell.id
                          ).config
                        );
                      })
                      .chainAfter(() => {
                        undoSvc.executeCommand(flComm);
                        this.model.endUpdate();
                      })
                  : activityCommands.create(activityData);
              break;
            }
          }
        }

        undoSvc.executeCommand(createCommand);
      } else if (!this.isEnabled()) {
        if (shiftDown) {
          const command = stickerCommands.create(
            diagramTypeConfigSvc.stickerNoteSettings.preparePayload({
              x,
              y,
              mxKey: -Date.now(), // this is hack to avoid mxKey overlap during simultanious editing
              position: PositionType.CENTER
            })
          );

          undoSvc.executeCommand(command);
        }
      }

      const mxe = new mxEventObject(mxEvent.DOUBLE_CLICK, 'event', evt, 'cell', cell);

      this.fireEvent(mxe);

      const notConsumed = !mxEvent.isConsumed(evt) && !mxe.isConsumed();

      if (notConsumed && cell && this.isCellEditable(cell) && !this.isEditing(cell)) {
        if (this.isEnabled()) {
          this.startEditingAtCell(cell, evt);
        } else if (isSticker(cell)) {
          stickersSvc.forceStartEditing(cell, evt);
        }

        mxEvent.consume(evt);
      }
    };

    /**
     * Adds a new label at the given position and returns the new cell. State is
     * an optional edge state to be used as the parent for the label. Vertices
     * are not allowed currently as states.
     */
    Graph.prototype.addText = function (x, y, state) {
      // Creates a new edge label with a predefined text
      const label = new mxCell();

      label.value = 'Text';
      label.style = 'text;html=1;resizable=0;';
      label.geometry = new mxGeometry(0, 0, 0, 0);
      label.connectable = false;
      label.vertex = true;

      if (state != null) {
        label.style += ';align=center;verticalAlign=middle;labelBackgroundColor=#ffffff;';
        label.geometry.relative = true;

        // Resets the relative location stored inside the geometry
        let pt2 = this.view.getRelativePoint(state, x, y);

        label.geometry.x = Math.round(pt2.x * 10000) / 10000;
        label.geometry.y = Math.round(pt2.y);

        // Resets the offset inside the geometry to find the offset from the resulting point
        label.geometry.offset = new mxPoint(0, 0);
        pt2 = this.view.getPoint(state, label.geometry);

        const scale = this.view.scale;

        label.geometry.offset = new mxPoint(
          Math.round((x - pt2.x) / scale),
          Math.round((y - pt2.y) / scale)
        );
      } else {
        label.style += 'autosize=1;align=left;verticalAlign=top;spacingTop=-4;';

        const tr = this.view.translate;

        label.geometry.width = '40';
        label.geometry.height = '20';
        label.geometry.x = Math.round(x / this.view.scale) - tr.x;
        label.geometry.y = Math.round(y / this.view.scale) - tr.y;
      }

      this.getModel().beginUpdate();

      try {
        this.addCells([label], state != null ? state.cell : null);
        this.fireEvent(new mxEventObject('cellsInserted', 'cells', [label]));
      } finally {
        this.getModel().endUpdate();
      }

      return label;
    };

    /**
     * Duplicates the given cells and returns the duplicates.
     */
    Graph.prototype.duplicateCells = function (cells, append) {
      cells = cells != null ? cells : this.getSelectionCells();
      append = append != null ? append : true;

      cells = this.model.getTopmostCells(cells);

      const model = this.getModel();
      const s = this.gridSize;
      const select = [];

      model.beginUpdate();

      try {
        for (let i = 0; i < cells.length; i++) {
          const parent = model.getParent(cells[i]);
          const child = this.moveCells([cells[i]], s, s, true, parent)[0];

          select.push(child);

          // Maintains child index by inserting after cloned in parent
          if (!append) {
            const index = parent.getIndex(cells[i]);

            model.add(parent, child, index + 1);
          }
        }
      } finally {
        model.endUpdate();
      }

      return select;
    };

    /**
     * Inserts the given image at the cursor in a content editable text box using
     * the insertimage command on the document instance and updates the size.
     */
    Graph.prototype.insertImage = function (newValue, w, h) {
      // To find the new image, we create a list of all existing links first
      if (newValue != null) {
        const tmp = this.cellEditor.text2.getElementsByTagName('img');
        const oldImages = [];

        for (let i = 0; i < tmp.length; i++) {
          oldImages.push(tmp[i]);
        }

        document.execCommand('insertimage', false, newValue);

        // Sets size of new image
        const newImages = this.cellEditor.text2.getElementsByTagName('img');

        if (newImages.length == oldImages.length + 1) {
          // Inverse order in favor of appended images
          for (let i = newImages.length - 1; i >= 0; i--) {
            if (i == 0 || newImages[i] != oldImages[i - 1]) {
              newImages[i].style.width = w + 'px';
              newImages[i].style.height = h + 'px';

              break;
            }
          }
        }
      }
    };

    /**
     *
     * @param cell
     * @returns {Boolean}
     */
    Graph.prototype.isCellResizable = function (cell) {
      const result = mxGraph.prototype.isCellResizable.apply(this, arguments);

      const state = this.view.getState(cell);
      const style = state != null ? state.style : this.getCellStyle(cell);

      return (
        result ||
        (mxUtils.getValue(style, mxConstants.STYLE_RESIZABLE, '1') != '0' &&
          style[mxConstants.STYLE_WHITE_SPACE] == 'wrap' &&
          !this.isCellLocked(cell))
      );
    };

    /**
     * Function similarSizeCells
     * Takes the first selected cell and changes the size of the other selected cells
     * to the size of this cell
     */

    Graph.prototype.similarSizeCells = function (useW, useH) {
      let cells = this.getSelectionCells();
      let templateCell, specialHeight;
      const RES_HEIGHT = 24;

      if (cells != null && cells.length > 1) {
        const gScope = this;

        cells = cells.filter(function (item) {
          const mainCodition = !isTerminator(item) && !isConnector(item) && !item.edge;

          if (mainCodition && !templateCell) {
            templateCell = item;
          }

          return mainCodition && !isImage(item) && !gScope.isCellLocked(item);
        });

        if (cells.length === 0) {
          return;
        }

        specialHeight =
          templateCell.geometry.height -
          diagramTypeConfigSvc.activitySettings().calcAddHeight(templateCell);
        this.model.beginUpdate();

        for (let i = 0; i < cells.length; i++) {
          const bounds = {x: 0, y: 0, width: 0, height: 0};
          const cell = cells[i];

          bounds.x = cell.geometry.x;
          bounds.y = cell.geometry.y;
          bounds.width = useW ? templateCell.geometry.width : cell.geometry.width;
          bounds.height = useH
            ? specialHeight + diagramTypeConfigSvc.activitySettings().calcAddHeight(cell)
            : cell.geometry.height;
          this.cellResized(cells[i], bounds, null, null, true);
        }

        this.model.endUpdate();
      }
    };

    Graph.prototype.customZoomFactor = 1.08;

    Graph.prototype.zoomToPointer = function (factor, mouseEvent) {
      // DON'T DELETE THIS MAGIC VALUE, NOT WORKING WITHOUT IT
      const MIN_SCALE = 0.007;

      const scale = Math.round(this.view.scale * factor * 1000) / 1000;

      if (scale < MIN_SCALE) {
        return;
      }

      const hasScrollbars = mxUtils.hasScrollbars(this.container);

      const containerOffset = mxUtils.getOffset(this.container);
      const clientX = mxEvent.getClientX(mouseEvent);
      const clientY = mxEvent.getClientY(mouseEvent);
      const mouseX = clientX - containerOffset.x + this.container.scrollLeft;
      const mouseY = clientY - containerOffset.y + this.container.scrollTop;

      const graphX = mouseX / this.view.scale - this.view.translate.x;
      const graphY = mouseY / this.view.scale - this.view.translate.y;

      this.view.setScale(scale);

      const newMouseX = (graphX + this.view.translate.x) * this.view.scale;
      const newMouseY = (graphY + this.view.translate.y) * this.view.scale;

      const dx = newMouseX - mouseX;
      const dy = newMouseY - mouseY;

      if (hasScrollbars) {
        this.container.scrollLeft += dx;
        this.container.scrollTop += dy;
      }
    };

    Graph.prototype.getVisibleEdgeCoordinatesOnGraph = function () {
      const container = this.container;
      const scale = this.view.scale;
      const translate = this.view.translate;

      const scrollLeft = container.scrollLeft || 0;
      const scrollTop = container.scrollTop || 0;

      const clientWidth = container.clientWidth;
      const clientHeight = container.clientHeight;

      const graphTopLeftX = (scrollLeft - translate.x * scale) / scale;
      const graphTopLeftY = (scrollTop - translate.y * scale) / scale;

      const viewRight = scrollLeft + clientWidth;
      const viewBottom = scrollTop + clientHeight;

      const graphBottomRightX = viewRight / scale - translate.x;
      const graphBottomRightY = viewBottom / scale - translate.y;

      return {
        topLeft: {x: graphTopLeftX, y: graphTopLeftY},
        botRight: {x: graphBottomRightX, y: graphBottomRightY}
      };
    };

    /**
     * Function: alignCells
     *
     * Aligns the given cells vertically or horizontally according to the given
     * alignment using the optional parameter as the coordinate.
     *
     * Parameters:
     *
     * align - Specifies the alignment. Possible values are all constants in
     * mxConstants with an ALIGN prefix.
     * cells - Array of <mxCells> to be aligned.
     * param - Optional coordinate for the alignment.
     */
    Graph.prototype.alignCells = function (align, cells, param) {
      if (cells == null) {
        cells = this.getSelectionCells();
      }

      if (cells != null && cells.length > 1) {
        const gScope = this;
        const noContainers = cells.every(cell => !cell.getJson?.().container || !isActivity(cell));
        const allContainers = cells.every(cell => cell.getJson?.().container || !isActivity(cell));

        if (!noContainers || !allContainers) {
          cells = cells.filter(item => {
            if (isActivity(item)) {
              const isInsideContainer = graphHelperSvc
                .allActivities()
                .some(
                  act => this.inGeoBounds(act, item) && act !== item && act.getJson().container
                );

              return !isInsideContainer;
            }

            return true;
          });
        }

        cells = cells.filter(function (item) {
          return !isTerminator(item) && !isConnector(item) && !gScope.isCellLocked(item);
        });

        // Finds the required coordinate for the alignment
        if (param == null) {
          for (let i = 0; i < cells.length; i++) {
            const state = this.view.getState(cells[i]);

            if (state != null && !this.model.isEdge(cells[i])) {
              if (param == null) {
                if (align == mxConstants.ALIGN_CENTER) {
                  param = state.x + state.width / 2;
                  break;
                } else if (align == mxConstants.ALIGN_RIGHT) {
                  param = state.x + state.width;
                } else if (align == mxConstants.ALIGN_TOP) {
                  param = state.y;
                } else if (align == mxConstants.ALIGN_MIDDLE) {
                  param = state.y + state.height / 2;
                  break;
                } else if (align == mxConstants.ALIGN_BOTTOM) {
                  param = state.y + state.height;
                } else {
                  param = state.x;
                }
              } else {
                if (align == mxConstants.ALIGN_RIGHT) {
                  param = Math.max(param, state.x + state.width);
                } else if (align == mxConstants.ALIGN_TOP) {
                  param = Math.min(param, state.y);
                } else if (align == mxConstants.ALIGN_BOTTOM) {
                  param = Math.max(param, state.y + state.height);
                } else {
                  param = Math.min(param, state.x);
                }
              }
            }
          }
        }

        // Aligns the cells to the coordinate
        if (param != null) {
          const s = this.view.scale;
          let dx, dy;

          this.model.beginUpdate();

          try {
            for (let i = 0; i < cells.length; i++) {
              const state = this.view.getState(cells[i]);

              if (state != null) {
                let geo = this.getCellGeometry(cells[i]);

                if (geo != null && !this.model.isEdge(cells[i])) {
                  geo = geo.clone();

                  if (align == mxConstants.ALIGN_CENTER) {
                    geo.x += (param - state.x - state.width / 2) / s;
                  } else if (align == mxConstants.ALIGN_RIGHT) {
                    geo.x += (param - state.x - state.width) / s;
                  } else if (align == mxConstants.ALIGN_TOP) {
                    geo.y += (param - state.y) / s;
                  } else if (align == mxConstants.ALIGN_MIDDLE) {
                    geo.y += (param - state.y - state.height / 2) / s;
                  } else if (align == mxConstants.ALIGN_BOTTOM) {
                    geo.y += (param - state.y - state.height) / s;
                  } else {
                    geo.x += (param - state.x) / s;
                  }

                  //resizeCells method changed to moveCells (so dx and dy were added)
                  dx = geo.x - cells[i].geometry.x;
                  dy = geo.y - cells[i].geometry.y;

                  this.keepLinesStraight = true; // need to keep lines straight
                  this.moveCells([cells[i]], dx, dy);
                  this.keepLinesStraight = false;
                }
              }
            }

            this.fireEvent(new mxEventObject(mxEvent.ALIGN_CELLS, 'align', align, 'cells', cells));
          } finally {
            this.model.endUpdate();
          }
        }
      }

      return cells;
    };

    /**
     * Function: distributeCells
     *
     * Aligns the given cells vertically or horizontally according to the given
     * alignment using the optional parameter as the coordinate.
     *
     * Parameters:
     *
     * horizontal - Boolean that specifies the direction of the distribution.
     * cells - Optional array of <mxCells> to be distributed. Edges are ignored.
     */
    //additional function
    Graph.prototype.distributeCells = function (horizontal, cells) {
      if (cells == null) {
        cells = this.getSelectionCells();
      }

      if (cells != null && cells.length > 1) {
        const vertices = [];
        let max = null;
        let min = null;

        for (let i = 0; i < cells.length; i++) {
          if (this.getModel().isVertex(cells[i]) && !this.isCellLocked(cells[i])) {
            const state = this.view.getState(cells[i]);

            if (state != null) {
              const tmp = horizontal ? state.getCenterX() : state.getCenterY();

              max = max != null ? Math.max(max, tmp) : tmp;
              min = min != null ? Math.min(min, tmp) : tmp;

              vertices.push(state);
            }
          }

          flowlineHelperSvc.analyzeCellsLines(vertices);
        }

        if (vertices.length > 2) {
          vertices.sort(function (a, b) {
            return horizontal ? a.x - b.x : a.y - b.y;
          });

          const t = this.view.translate;
          const s = this.view.scale;

          min = min / s - (horizontal ? t.x : t.y);
          max = max / s - (horizontal ? t.x : t.y);

          this.getModel().beginUpdate();

          try {
            const dt = (max - min) / (vertices.length - 1);
            let t0 = min;

            for (let i = 1; i < vertices.length - 1; i++) {
              let geo = this.getCellGeometry(vertices[i].cell);

              t0 += dt;
              let dx, dy;

              if (geo != null) {
                geo = geo.clone();

                if (horizontal) {
                  geo.x = Math.round(t0 - geo.width / 2);
                } else {
                  geo.y = Math.round(t0 - geo.height / 2);
                }

                dx = geo.x - vertices[i].cell.geometry.x;
                dy = geo.y - vertices[i].cell.geometry.y;
                this.getModel().setGeometry(vertices[i].cell, geo);
                // do this after vertex geo was updated as below calculation uses updated values
                flowlineHelperSvc.translateConnectedEdges([vertices[i].cell], {dx, dy});
              }
            }
          } finally {
            this.getModel().endUpdate();
          }
        }
      }

      return cells;
    };

    // TODO: Implement text-wrapping here!
    Graph.prototype.isLabelClipped = function (state) {
      if (isText(state)) {
        return true;
      }

      return mxGraph.prototype.isLabelClipped.apply(this, arguments);
    };

    /**
     * Function: cellsMoved
     *
     * Moves the specified cells by the given vector, disconnecting the cells
     * using disconnectGraph is disconnect is true. This method fires
     * <mxEvent.CELLS_MOVED> while the transaction is in progress.
     */
    Graph.prototype.cellsMoved = function (cells, dx, dy, disconnect, constrain, extend) {
      if (cells != null && (dx != 0 || dy != 0)) {
        extend = extend != null ? extend : false;

        // Removes descandants with ancestors in cells to avoid multiple moving
        cells = this.model.getTopmostCells(cells);

        // additional code
        // if (mapService.isSFA()) {
        cells.forEach(cell => {
          if (isActivity(cell)) {
            if (cell.getJson().container) {
              const containerIndex = graphHelperSvc.allActivities().indexOf(cell);

              graphHelperSvc
                .allActivities()
                .filter((a, index) => index > containerIndex && this.inGeoBounds(cell, a))
                .forEach(a => cells.push(a));
            }
          }
        });
        // }

        flowlineHelperSvc.analyzeCellsLines(cells, true);

        cells.forEach(cell => {
          if (isActivity(cell) && cell.edges) {
            const edges = cell.edges;

            edges.forEach(edge => {
              if (
                edge.target &&
                edge.source &&
                (isTerminator(edge.target) || isTerminator(edge.source))
              ) {
                const terminator = isTerminator(edge.target) ? edge.target : edge.source;

                cells.push(terminator);
              }
            });
          }
        });
        cells = _.uniq(cells);
        // end of additional

        this.model.beginUpdate();

        try {
          if (disconnect) {
            this.disconnectGraph(cells);
          }

          for (let i = 0; i < cells.length; i++) {
            this.translateCell(cells[i], dx, dy);

            if (extend && this.isExtendParent(cells[i])) {
              this.extendParent(cells[i]);
            } else if (constrain) {
              this.constrainChild(cells[i]);
            }
          }

          flowlineHelperSvc.translateConnectedEdges(cells, {dx, dy});

          if (this.resetEdgesOnMove) {
            this.resetEdges(cells);
          }

          this.fireEvent(
            new mxEventObject(
              mxEvent.CELLS_MOVED,
              'cells',
              cells,
              'dx',
              dx,
              'dy',
              dy,
              'disconnect',
              disconnect
            )
          );
        } finally {
          this.model.endUpdate();
        }
      }
    };

    /**
     * Function: cellResized
     *
     * Resizes the parents recursively so that they contain the complete area
     * of the resized child cell.
     *
     * Parameters:
     *
     * cell - <mxCell> whose bounds should be changed.
     * bounds - <mxRectangles> that represent the new bounds.
     * ignoreRelative - Boolean that indicates if relative cells should be ignored.
     * recurse - Optional boolean that specifies if the children should be resized.
     */
    Graph.prototype.cellResized = function (cell, bounds, ignoreRelative, recurse, ignoreModel) {
      let geo = this.model.getGeometry(cell);

      flowlineHelperSvc.analyzeCellsLines([cell]);

      if (
        geo != null &&
        (geo.x != bounds.x ||
          geo.y != bounds.y ||
          geo.width != bounds.width ||
          geo.height != bounds.height)
      ) {
        geo = geo.clone();
        const resizing = {
          dx: bounds.width - geo.width,
          dy: bounds.height - geo.height
        };

        const moving = {
          dx: bounds.x - geo.x,
          dy: bounds.y - geo.y
        };

        if (!ignoreRelative && geo.relative) {
          const offset = geo.offset;

          if (offset != null) {
            offset.x += bounds.x - geo.x;
            offset.y += bounds.y - geo.y;
          }
        } else {
          geo.x = bounds.x;
          geo.y = bounds.y;
        }

        geo.width = bounds.width;
        geo.height = bounds.height;

        if (!geo.relative && this.model.isVertex(cell) && !this.isAllowNegativeCoordinates()) {
          geo.x = Math.max(0, geo.x);
          geo.y = Math.max(0, geo.y);
        }

        !ignoreModel && this.model.beginUpdate();

        try {
          if (recurse) {
            this.resizeChildCells(cell, geo);
          }

          this.model.setGeometry(cell, geo);

          flowlineHelperSvc.translateConnectedEdges([cell], moving, resizing);

          // todo: if you want to use new version use only method without a check
          if (this.isConstrainChildrenOnResize()) {
            this.constrainChildCells(cell);
          }

          // This event is fired to make the matchSize activity option to change context toolbar position.
          this.fireEvent(new mxEventObject(mxEvent.CELLS_RESIZED));
        } finally {
          !ignoreModel && this.model.endUpdate();
        }
      }
    };

    /**
     * Customized graph for touch devices.
     */
    Graph.prototype.initTouch = function () {
      // Disables new connections via "hotspot"
      this.connectionHandler.marker.isEnabled = function () {
        return this.graph.connectionHandler.first != null;
      };

      // Hides menu when editing starts
      this.addListener(mxEvent.START_EDITING, function (sender, evt) {
        this.popupMenuHandler.hideMenu();
      });

      // Adds custom hit detection if native hit detection found no cell
      this.updateMouseEvent = function (me) {
        me = mxGraph.prototype.updateMouseEvent.apply(this, arguments);

        if (mxEvent.isTouchEvent(me.getEvent()) && me.getState() == null) {
          let cell = this.getCellAt(me.graphX, me.graphY);

          if (
            cell != null &&
            this.isSwimlane(cell) &&
            this.hitsSwimlaneContent(cell, me.graphX, me.graphY)
          ) {
            cell = null;
          } else {
            me.state = this.view.getState(cell);

            if (me.state != null && me.state.shape != null) {
              this.container.style.cursor = me.state.shape.node.style.cursor;
            }
          }
        }

        if (me.getState() == null) {
          this.container.style.cursor = 'default';
        }

        return me;
      };

      // Context menu trigger implementation depending on current selection state
      // combined with support for normal popup trigger.
      let cellSelected = false;
      let selectionEmpty = false;
      let menuShowing = false;

      this.fireMouseEvent = function (evtName, me, sender) {
        if (evtName == mxEvent.MOUSE_DOWN) {
          // For hit detection on edges
          me = this.updateMouseEvent(me);

          cellSelected = this.isCellSelected(me.getCell());
          selectionEmpty = this.isSelectionEmpty();
          menuShowing = this.popupMenuHandler.isMenuShowing();
        }

        mxGraph.prototype.fireMouseEvent.apply(this, arguments);
      };

      // Shows popup menu if cell was selected or selection was empty and background was clicked
      // FIXME: Conflicts with mxPopupMenuHandler.prototype.getCellForPopupEvent in Editor.js by
      // selecting parent for selected children in groups before this check can be made.
      this.popupMenuHandler.mouseUp = mxUtils.bind(this, function (sender, me) {
        this.popupMenuHandler.popupTrigger =
          !this.isEditing() &&
          (this.popupMenuHandler.popupTrigger ||
            (!menuShowing &&
              !mxEvent.isMouseEvent(me.getEvent()) &&
              ((selectionEmpty && me.getCell() == null && this.isSelectionEmpty()) ||
                (cellSelected && this.isCellSelected(me.getCell())))));
        mxPopupMenuHandler.prototype.mouseUp.apply(this.popupMenuHandler, arguments);
      });
    };

    //// IN PLACE EDITOR

    (function () {
      // Implement minimum width and height styles
      const vertexHandlerUnion = mxVertexHandler.prototype.union;

      mxVertexHandler.prototype.union = function (bounds, dx, dy, index, gridEnabled, scale, tr) {
        const result = vertexHandlerUnion.apply(this, arguments);

        if (this.state.cell && isImage(this.state.cell)) {
          const coff = bounds.width / bounds.height;

          result.width = result.height * coff;

          return result;
        }

        result.width = Math.max(result.width, mxUtils.getNumber(this.state.style, 'minWidth', 0));
        result.height = Math.max(
          result.height,
          mxUtils.getNumber(this.state.style, 'minHeight', 0)
        );
        const max = {
          width: mxUtils.getNumber(this.state.style, 'maxWidth', 0),
          height: mxUtils.getNumber(this.state.style, 'maxHeight', 0)
        };

        if (max.width && max.height) {
          result.width = Math.min(result.width, max.width);
          result.height = Math.min(result.height, max.height);
        }

        return result;
      };

      /**
       * Refresh vertex content during resize drag
       */
      mxVertexHandler.prototype.mouseMove = function (sender, me) {
        const scale = this.graph.view.scale;
        let dx, dy;

        if (!me.isConsumed() && this.index != null) {
          // Checks tolerance for ignoring single clicks
          this.checkTolerance(me);

          if (!this.inTolerance) {
            const point = new mxPoint(me.getGraphX(), me.getGraphY());
            const gridEnabled = this.graph.isGridEnabledEvent(me.getEvent());
            const tr = this.graph.view.translate;

            if (this.index <= mxEvent.CUSTOM_HANDLE) {
              if (this.customHandles != null) {
                this.customHandles[mxEvent.CUSTOM_HANDLE - this.index].processEvent(me);
              }
            } else if (this.index == mxEvent.LABEL_HANDLE) {
              if (gridEnabled) {
                point.x = (this.graph.snap(point.x / scale - tr.x) + tr.x) * scale;
                point.y = (this.graph.snap(point.y / scale - tr.y) + tr.y) * scale;
              }

              this.moveSizerTo(this.sizers[this.sizers.length - 1], point.x, point.y);
            } else if (this.index == mxEvent.ROTATION_HANDLE) {
              const dx = this.state.x + this.state.width / 2 - point.x;
              const dy = this.state.y + this.state.height / 2 - point.y;

              this.currentAlpha =
                dx != 0 ? (Math.atan(dy / dx) * 180) / Math.PI + 90 : dy < 0 ? 180 : 0;

              if (dx > 0) {
                this.currentAlpha -= 180;
              }

              // Rotation raster
              if (this.rotationRaster && this.graph.isGridEnabledEvent(me.getEvent())) {
                const dx = point.x - this.state.getCenterX();
                const dy = point.y - this.state.getCenterY();
                const dist = Math.abs(Math.sqrt(dx * dx + dy * dy) - 20) * 3;
                const raster = Math.max(
                  1,
                  5 * Math.min(3, Math.max(0, Math.round(80 / Math.abs(dist))))
                );

                this.currentAlpha = Math.round(this.currentAlpha / raster) * raster;
              } else {
                this.currentAlpha = this.roundAngle(this.currentAlpha);
              }

              this.selectionBorder.rotation = this.currentAlpha;
              this.selectionBorder.redraw();

              if (this.livePreview) {
                this.redrawHandles();
              }
            } else {
              const alpha = mxUtils.toRadians(this.state.style[mxConstants.STYLE_ROTATION] || '0');
              let cos = Math.cos(-alpha); //-1
              let sin = Math.sin(-alpha); //0

              const ct = new mxPoint(this.state.getCenterX(), this.state.getCenterY());

              dx = point.x - this.startX;
              dy = point.y - this.startY;

              // Rotates vector for mouse gesture
              const tx = cos * dx - sin * dy;
              const ty = sin * dx + cos * dy;

              dx = tx;
              dy = ty;

              const geo = this.graph.getCellGeometry(this.state.cell);

              this.unscaledBounds = this.union(
                geo,
                dx / scale,
                dy / scale,
                this.index,
                gridEnabled,
                1,
                new mxPoint(0, 0),
                this.isConstrainedEvent(me)
              );
              this.bounds = new mxRectangle(
                (this.parentState != null ? this.parentState.x : tr.x * scale) +
                  this.unscaledBounds.x * scale,
                (this.parentState != null ? this.parentState.y : tr.y * scale) +
                  this.unscaledBounds.y * scale,
                this.unscaledBounds.width * scale,
                this.unscaledBounds.height * scale
              );

              if (geo.relative && this.parentState != null) {
                this.bounds.x += this.state.x - this.parentState.x;
                this.bounds.y += this.state.y - this.parentState.y;
              }

              cos = Math.cos(alpha);
              sin = Math.sin(alpha);

              const c2 = new mxPoint(this.bounds.getCenterX(), this.bounds.getCenterY());

              dx = c2.x - ct.x;
              dy = c2.y - ct.y;

              const dx2 = cos * dx - sin * dy;
              const dy2 = sin * dx + cos * dy;

              const dx3 = dx2 - dx;
              const dy3 = dy2 - dy;

              const dx4 = this.bounds.x - this.state.x;
              const dy4 = this.bounds.y - this.state.y;

              const dx5 = cos * dx4 - sin * dy4;
              const dy5 = sin * dx4 + cos * dy4;

              this.bounds.x += dx3;
              this.bounds.y += dy3;

              // Rounds unscaled bounds to int
              this.unscaledBounds.x = this.roundLength(this.unscaledBounds.x + dx3 / scale);
              this.unscaledBounds.y = this.roundLength(this.unscaledBounds.y + dy3 / scale);
              this.unscaledBounds.width = this.roundLength(this.unscaledBounds.width);
              this.unscaledBounds.height = this.roundLength(this.unscaledBounds.height);

              // Shifts the children according to parent offset
              if (!this.graph.isCellCollapsed(this.state.cell) && (dx3 != 0 || dy3 != 0)) {
                this.childOffsetX = this.state.x - this.bounds.x + dx5;
                this.childOffsetY = this.state.y - this.bounds.y + dy5;
              } else {
                this.childOffsetX = 0;
                this.childOffsetY = 0;
              }

              if (this.livePreview) {
                // Saves current state
                const tmp = new mxRectangle(
                  this.state.x,
                  this.state.y,
                  this.state.width,
                  this.state.height
                );
                const orig = this.state.origin;

                // Temporarily changes size and origin
                this.state.x = this.bounds.x;
                this.state.y = this.bounds.y;
                this.state.origin = new mxPoint(
                  this.state.x / scale - tr.x,
                  this.state.y / scale - tr.y
                );
                this.state.width = this.bounds.width;
                this.state.height = this.bounds.height;

                // Redraws cell and handles
                let off = this.state.absoluteOffset;

                off = new mxPoint(off.x, off.y);

                // Required to store and reset absolute offset for updating label position
                this.state.absoluteOffset.x = 0;
                this.state.absoluteOffset.y = 0;
                const geo = this.graph.getCellGeometry(this.state.cell);

                if (geo != null) {
                  const offset = geo.offset || this.EMPTY_POINT;

                  if (offset != null && !geo.relative) {
                    this.state.absoluteOffset.x = this.state.view.scale * offset.x;
                    this.state.absoluteOffset.y = this.state.view.scale * offset.y;
                  }

                  this.state.view.updateVertexLabelOffset(this.state);
                }

                // Redraws connected edges
                this.state.view.invalidate(this.state.cell);
                this.state.invalid = false;
                this.state.view.validate();
                this.redrawHandles();

                // Restores current state
                this.state.x = tmp.x;
                this.state.y = tmp.y;
                this.state.width = tmp.width;
                this.state.height = tmp.height;
                this.state.origin = orig;
                this.state.absoluteOffset = off;
              }

              if (this.preview != null) {
                this.drawPreview();
              }
            }

            this.updateHint(me);
          }

          me.consume();
        } else if (!this.graph.isMouseDown && this.getHandleForEvent(me) != null) {
          // Workaround for disabling the connect highlight when over handle
          me.consume(false);
        }
      };

      /**
       * Handling of special nl2Br style for not converting newlines to breaks in HTML labels.
       * NOTE: Since it's easier to set this when the label is created we assume that it does
       * not change during the lifetime of the mxText instance.
       */
      const mxCellRendererInitializeLabel = mxCellRenderer.prototype.initializeLabel;

      mxCellRenderer.prototype.initializeLabel = function (state, shape) {
        if (state.text != null) {
          state.text.replaceLinefeeds = mxUtils.getValue(state.style, 'nl2Br', '1') != '0';
        }

        mxCellRendererInitializeLabel.apply(this, arguments);
      };

      const mxConstraintHandlerUpdate = mxConstraintHandler.prototype.update;

      mxConstraintHandler.prototype.update = function (me, source) {
        if (this.isKeepFocusEvent(me) || !mxEvent.isAltDown(me.getEvent())) {
          mxConstraintHandlerUpdate.apply(this, arguments);
        } else {
          this.reset();
        }
      };

      /**
       * No dashed shapes.
       */
      mxGuide.prototype.createGuideShape = function (horizontal) {
        const guide = new mxPolyline([], mxConstants.GUIDE_COLOR, mxConstants.GUIDE_STROKEWIDTH);

        return guide;
      };

      if ('contentEditable' in document.documentElement) {
        mxCellEditor.prototype.autoSize = true;

        /**
         * Function: isHideLabel
         *
         * Returns true if the label should be hidden while the cell is being
         * edited.
         */
        mxCellEditor.prototype.isHideLabel = function (state) {
          return !isActivity(state.cell);
        };

        /**
         * HTML in-place editor
         */
        const mxCellEditorStartEditing = mxCellEditor.prototype.startEditing;

        mxCellEditor.prototype.startEditing = function (cell, trigger) {
          this.graph.setEnterStopsCellEditing(false);

          if (isActivity(cell)) {
            const specialTarget = trigger?.target.closest('[special-target]');

            if (specialTarget) {
              trigger.specialTarget = specialTarget;
              trigger.specialTargetName = specialTarget.getAttribute('special-target');
              this.graph.setEnterStopsCellEditing(true);
            }
          }

          const lineOnSFA = isFlowline(cell) && diagramTypeConfigSvc.isArchitecture();

          /**
           * Do not start editing if modal instance is open
           */
          // if(modalService.isAnyOpen()) { // @TODO: check for opened dialogs
          //   return;
          // }

          /**
           * Hide mxGraph tooltips
           */
          this.graph.tooltipHandler.hideTooltip();

          /**
           * Hide mxGraph navite context menu
           */
          this.graph.popupMenuHandler.hideMenu();

          this.switchSelectionState = null;

          // Selects editing cell
          this.graph.setSelectionCell(cell);

          // First run cannot set display before supercall because textarea is lazy created
          // Lazy instantiates textarea to save memory in IE
          if (this.textarea == null) {
            this.init();
          }

          const state = this.graph.view.getState(cell);

          if (state != null && state.style['html'] == 1) {
            this.textarea.style.display = 'none';
          } else {
            this.textarea.style.display = 'block';
          }

          mxCellEditorStartEditing.apply(this, arguments);

          /**
           *
           */
          if (isActivity(cell)) {
            // cell.comp.instance.isEditing = true;
            cell.comp.instance.isEditing.next(true);
          }

          // Enables focus outline for edges and edge labels
          const parent = this.graph.getModel().getParent(cell);
          const geo = this.graph.getCellGeometry(cell);

          /**
           * Edge
           */
          if (
            (this.graph.getModel().isEdge(parent) && geo != null && geo.relative) ||
            this.graph.getModel().isEdge(cell)
          ) {
            // Quirks does not support outline at all so use border instead
            if (mxClient.IS_QUIRKS) {
              this.textarea.style.border = 'gray dotted 1px';
            } else if (mxClient.IS_IE || mxClient.IS_IE11 || (mxClient.IS_FF && mxClient.IS_WIN)) {
              // IE>8 and FF on Windows uses outline default of none
              this.textarea.style.outline = 'gray dotted 1px';
            } else {
              this.textarea.style.outline = '';
            }
          } else if (mxClient.IS_QUIRKS) {
            this.textarea.style.border = '';
          }

          if (this.textarea.style.display == 'none') {
            this.text2 = document.createElement('div');
            this.text2.className = 'geContentEditable';

            //id added for making possible to get this html-element and retrieve its content
            this.text2.id = 'editingarea';

            const nl2Br = mxUtils.getValue(state.style, 'nl2Br', '1') != '0';

            this.text2.innerHTML = this.graph.sanitizeHtml(
              nl2Br ? this.textarea.value.replace(/\n/g, '<br/>') : this.textarea.value
            );

            this.text2.onmouseup = function () {
              _saveCurrentSelection();
            };

            this.text2.onkeyup = function () {
              _saveCurrentSelection();
            };

            mxEvent.addListener(this.text2, 'paste', evt => {
              evt.preventDefault();
              const clipBoard = evt.clipboardData || window['clipboardData'];
              let pasteData = clipBoard.getData('text/html');

              if (
                (diagramTypeConfigSvc.isArchitecture() && isActivity(this.editingCell)) ||
                !pasteData
              ) {
                pasteData = DOMPurify.sanitize(clipBoard.getData('text/plain'));
              } else {
                const pasteParent = document.createElement('font');

                pasteParent.innerHTML = DOMPurify.sanitize(pasteData);

                const children = pasteParent.getElementsByTagName('*');

                for (let i = 0; i < children.length; i++) {
                  const child = children[i] as HTMLElement;

                  child.style.removeProperty('font-size');
                  child.style.removeProperty('background-color');
                }

                const fontSizeTag = textEditStyleSvc.fontSizeTag;
                const focusNode = window.getSelection().focusNode;

                if (fontSizeTag && focusNode?.nodeType === Node.TEXT_NODE) {
                  pasteParent.style.fontSize = fontSizeTag.style.fontSize;
                }

                pasteData = pasteParent.outerHTML;
              }

              if (mxClient.IS_IE) {
                document.execCommand('paste', false, pasteData);
              } else {
                document.execCommand('insertHTML', false, pasteData);
              }
            });

            // NOTE: The next line is complete BS - remove UA sniffing as positively no need for it

            const evtName =
              !mxClient.IS_IE11 && (!mxClient.IS_IE || document['documentMode'] >= 9)
                ? 'input'
                : 'keypress';

            mxEvent.addListener(
              this.text2,
              evtName,
              mxUtils.bind(this, function (evt) {
                if (
                  this.autoSize &&
                  !mxEvent.isConsumed(evt) &&
                  !isActivity(cell) &&
                  !isSticker(cell) &&
                  !lineOnSFA
                ) {
                  setTimeout(
                    mxUtils.bind(this, function () {
                      this.resize();
                    }),
                    0
                  );
                }
              })
            );

            // Invokes stop editing and escape hooks
            mxEvent.addListener(
              this.text2,
              'keydown',
              mxUtils.bind(this, function (evt) {
                if (!mxEvent.isConsumed(evt)) {
                  if (this.isStopEditingEvent(evt)) {
                    this.graph.stopEditing(false);
                    mxEvent.consume(evt);
                  } else if (evt.keyCode == 27 /* Escape */) {
                    this.graph.stopEditing(false);
                    mxEvent.consume(evt);
                  }
                }
              })
            );

            const style = this.text2.style;

            //noinspection TypeScriptUnresolvedFunction
            /**
             * Extend text editor styles with some business logic
             */

            Object.assign(style, textEditStyleSvc.getEditorStylings(cell, this.textarea, trigger));

            const dir = this.textarea.getAttribute('dir');

            if (dir != null && dir.length > 0) {
              this.text2.setAttribute('dir', dir);
            }

            // Matches line height correctionFactor in embedded HTML output
            if (
              state.text != null &&
              state.text.node != null &&
              state.text.node.ownerSVGElement != null
            ) {
              const lh = mxConstants.ABSOLUTE_LINE_HEIGHT
                ? Math.round(parseInt(this.textarea.style.fontSize) * mxConstants.LINE_HEIGHT) +
                  'px'
                : mxConstants.LINE_HEIGHT * mxSvgCanvas2D.prototype.lineHeightCorrection;

              style.lineHeight = lh;
            } else {
              style.lineHeight = this.textarea.style.lineHeight;
            }

            this.graph.container.appendChild(this.text2);

            if (this.autoSize && !isActivity(cell) && !isSticker(cell) && !lineOnSFA) {
              this.textDiv = this.createTextDiv();
              document.body.appendChild(this.textDiv);
              this.resize();
            }

            this.text2.contentEditable = true;
            this.text2.focus();

            if (this.isSelectText() && this.text2.innerHTML.length > 0) {
              document.execCommand('selectAll', false, null);
              _saveCurrentSelection();
            }

            // Hides handles on selected cell
            this.currentStateHandle = this.graph.selectionCellsHandler.getHandler(cell);

            if (
              this.currentStateHandle != null &&
              this.currentStateHandle.setHandlesVisible != null
            ) {
              this.currentStateHandle.setHandlesVisible(false);

              // Hides the bounding box
              if (this.currentStateHandle.selectionBorder != null) {
                this.currentStateHandle.selectionBorder.node.style.display = 'none';
              }
            }
          }
        };

        mxGraph.prototype.getConnectionPoint = function (vertex, constraint, round) {
          round = round ?? true;
          let point = null;

          if (vertex != null && constraint.point != null) {
            const bounds = this.view.getPerimeterBounds(vertex);
            const cx = new mxPoint(bounds.getCenterX(), bounds.getCenterY());
            const direction = vertex.style[mxConstants.STYLE_DIRECTION];
            let r1 = 0;

            // Bounds need to be rotated by 90 degrees for further computation
            if (direction != null) {
              if (direction == mxConstants.DIRECTION_NORTH) {
                r1 += 270;
              } else if (direction == mxConstants.DIRECTION_WEST) {
                r1 += 180;
              } else if (direction == mxConstants.DIRECTION_SOUTH) {
                r1 += 90;
              }

              // Bounds need to be rotated by 90 degrees for further computation
              if (
                direction == mxConstants.DIRECTION_NORTH ||
                direction == mxConstants.DIRECTION_SOUTH
              ) {
                bounds.rotate90();
              }
            }

            if (constraint.point != null) {
              let sx = 1;
              let sy = 1;
              let dx = 0;
              let dy = 0;

              // LATER: Add flipping support for image shapes
              if (this.getModel().isVertex(vertex.cell)) {
                let flipH = vertex.style[mxConstants.STYLE_FLIPH];
                let flipV = vertex.style[mxConstants.STYLE_FLIPV];

                // Legacy support for stencilFlipH/V
                if (vertex.shape != null && vertex.shape.stencil != null) {
                  flipH = mxUtils.getValue(vertex.style, 'stencilFlipH', 0) == 1 || flipH;
                  flipV = mxUtils.getValue(vertex.style, 'stencilFlipV', 0) == 1 || flipV;
                }

                if (
                  direction == mxConstants.DIRECTION_NORTH ||
                  direction == mxConstants.DIRECTION_SOUTH
                ) {
                  const tmp = flipH;

                  flipH = flipV;
                  flipV = tmp;
                }

                if (flipH) {
                  sx = -1;
                  dx = -bounds.width;
                }

                if (flipV) {
                  sy = -1;
                  dy = -bounds.height;
                }
              }

              point = new mxPoint(
                bounds.x + constraint.point.x * bounds.width * sx - dx,
                bounds.y + constraint.point.y * bounds.height * sy - dy
              );
            }

            // Rotation for direction before projection on perimeter
            let r2 = vertex.style[mxConstants.STYLE_ROTATION] || 0;

            if (constraint.perimeter) {
              if (r1 != 0 && point != null) {
                // Only 90 degrees steps possible here so no trig needed
                let cos = 0;
                let sin = 0;

                if (r1 == 90) {
                  sin = 1;
                } else if (r1 == 180) {
                  cos = -1;
                } else if (r1 == 270) {
                  sin = -1;
                }

                point = mxUtils.getRotatedPoint(point, cos, sin, cx);
              }

              if (point != null && constraint.perimeter) {
                point = this.view.getPerimeterPoint(vertex, point, false);
              }
            } else {
              r2 += r1;
            }

            // Generic rotation after projection on perimeter
            if (r2 != 0 && point != null) {
              const rad = mxUtils.toRadians(r2);
              const cos = Math.cos(rad);
              const sin = Math.sin(rad);

              point = mxUtils.getRotatedPoint(point, cos, sin, cx);
            }
          }

          if (round && point != null) {
            point.x = Math.round(point.x);
            point.y = Math.round(point.y);
          }

          return point;
        };

        mxGraph.prototype.isCellCloneable = function (cell) {
          return false;
        };

        const mxCellEditorStopEditing = mxCellEditor.prototype.stopEditing;

        mxCellEditor.prototype.stopEditing = function (cancel) {
          if (!this.editingCell) {
            return;
          }

          let rect;

          // Hides handles on selected cell
          if (this.currentStateHandle != null) {
            if (this.currentStateHandle.setHandlesVisible != null) {
              this.currentStateHandle.setHandlesVisible(true);

              if (this.currentStateHandle.selectionBorder != null) {
                this.currentStateHandle.selectionBorder.node.style.display = '';
              }
            }

            this.currentStateHandle = null;
          }

          const valueChanged = this.textarea.value != this.text2.innerHTML;

          const hasInnerText = Boolean(this.text2.innerText?.trim());

          if (this.text2 != null) {
            const content = this.text2.innerHTML;
            const cell = this.editingCell;
            const scale = 1 / this.graph.view.scale;

            rect = new mxRectangle(
              cell.geometry.x,
              cell.geometry.y,
              this.text2.offsetWidth * scale,
              this.text2.offsetHeight * scale
            );

            // Modified state also updated in code view action
            if (this.text2.style.display != 'none' && valueChanged) {
              this.textarea.value = content.replace(/\r\n/g, '').replace(/\n/g, '');
              this.setModified(true);
            } else {
              const state = this.graph.view.getState(this.editingCell);
              const nl2Br = state != null && mxUtils.getValue(state.style, 'nl2Br', '1') != '0';

              if (nl2Br) {
                this.textarea.value = this.textarea.value
                  .replace(/\r\n/g, '<br/>')
                  .replace(/\n/g, '<br/>');
              }
            }

            this.textarea.value = this.graph.sanitizeHtml(this.textarea.value);
            this.text2.parentNode.removeChild(this.text2);
            this.text2 = null;
          }

          // Removes empty relative child labels in edges
          const cell = this.editingCell;

          if (cell && cell.value === '' && cell.editingValue) {
            cell.value = cell.editingValue;
            delete cell.editingValue;
          }

          if (isActivity(cell)) {
            if (!this.trigger?.specialTarget) {
              cell.comp.instance.textSub.next(this.textarea.value);
            }

            cell.comp.instance.isEditing.next(false);
          }

          if (this.trigger?.specialTarget) {
            if (this.trigger.specialTargetName === 'footerText') {
              let footerText = mxUtils.trim(this.textarea.value);

              if (!hasInnerText) {
                footerText = '';
              }

              const command = activityCommands.changeFooterText({
                mxKey: cell.id,
                footerText
              });

              undoSvc.executeCommand(command);

              this.graph.contextBar?.updateOptions();
            }

            if (this.trigger.specialTargetName === 'attributeItem') {
              let text = mxUtils.trim(this.textarea.value);
              const params = {
                mxKey: this.trigger.specialTarget.getAttribute('mx-key'),
                activityMxKey: cell.id
              };

              if (!hasInnerText) {
                text = '';
              }

              const command = text
                ? activityCommands.changeAttribute({...params, text})
                : activityCommands.deleteAttribute(params);

              undoSvc.executeCommand(command);
            }
          }

          this.graph.getModel().beginUpdate();

          try {
            mxCellEditorStopEditing.apply(this, arguments);

            if (isLineText(cell)) {
              const trimmedValue = mxUtils.trim(this.textarea.value);
              // mxGraph puts <br> instead of empty string sometimes for empty labels
              const shouldDelete = ['', '<br>'].includes(trimmedValue);

              if (shouldDelete) {
                const commandData = {flowlineMxKey: cell.parent.id, key: cell.key};
                const command = flowlineCommands.deleteLineText(commandData);

                undoSvc.executeCommand(command);
              }
            }
          } finally {
            this.graph.getModel().endUpdate();
          }

          this.graph.container.focus();

          if (!valueChanged) {
            this.graph.refresh(cell);
          }
        };

        const mxCellEditorResize = mxCellEditor.prototype.resize;

        mxCellEditor.prototype.resize = function () {
          // Shows in full size for HTML source mode
          const lineOnSfa = isFlowline(this.editingCell) && mapService.isSFA();

          if ((this.text2 != null && this.textarea.style.display != 'none') || !this.textDiv) {
            const state = this.graph.getView().getState(this.editingCell);

            if ((state != null && this.graph.getModel().isVertex(state.cell)) || lineOnSfa) {
              let x = state.x;
              let y = state.y;
              let w = state.width;
              let h = state.height;

              if (lineOnSfa) {
                const textWidth = parseInt(this.text2.offsetWidth);
                const textPadding = parseInt(this.text2.style.paddingLeft);

                x = state.absoluteOffset.x - textWidth / 2 + textPadding;
                y = state.absoluteOffset.y;
              }

              if (w <= 1 && h <= 1) {
                w = Math.max(w, 120);
                h = Math.max(h, 40);
                let m = state.text != null ? state.text.margin : null;

                if (m == null) {
                  const align = mxUtils.getValue(
                    state.style,
                    mxConstants.STYLE_ALIGN,
                    mxConstants.ALIGN_CENTER
                  );
                  const valign = mxUtils.getValue(
                    state.style,
                    mxConstants.STYLE_VERTICAL_ALIGN,
                    mxConstants.ALIGN_MIDDLE
                  );

                  m = mxUtils.getAlignmentAsPoint(align, valign);
                }

                x += m.x * w;
                y += m.y * h;
              }

              this.textarea.style.left = Math.round(x) + 'px';
              this.textarea.style.top = Math.round(y) + 'px';
              this.textarea.style.width = Math.round(w) + 'px';
              this.textarea.style.height = Math.round(h) + 'px';
            }
          } else {
            Object.assign(
              this.text2.style,
              textEditStyleSvc.getEditorStylings(this.editingCell, this.textarea)
            );

            mxCellEditorResize.apply(this, arguments);
          }

          if (this.textarea.style.display == 'none' && this.text2 != null) {
            this.text2.style.top = this.textarea.style.top;
            this.text2.style.left = this.textarea.style.left;
            this.text2.style.width = this.textarea.style.width;
            this.text2.style.height = this.textarea.style.height;
          }

          Object.assign(
            this.text2.style,
            textEditStyleSvc.getEditorStylings(this.editingCell, this.textarea, this.trigger)
          );
        };

        /**
         * Function: createTextDiv
         *
         * Creates the textDiv used for measuring text.
         */
        mxCellEditor.prototype.createTextDiv = function () {
          const div = document.createElement('div');
          const style = div.style;

          div.className = 'textDiv';
          style.position = 'absolute';
          style.whiteSpace = 'nowrap';
          style.visibility = 'hidden';
          style.padding = '0px';
          style.margin = '0px';
          style.display = mxClient.IS_QUIRKS ? 'inline' : 'inline-block';
          // @ts-ignore
          style.zoom = '1';
          style.verticalAlign = 'top';
          style.lineHeight = this.textarea.style.lineHeight;
          style.fontSize = this.textarea.style.fontSize;
          style.fontFamily = this.textarea.style.fontFamily;
          style.fontWeight = this.textarea.style.fontWeight;
          style.textAlign = this.textarea.style.textAlign;
          style.fontStyle = this.textarea.style.fontStyle;
          style.textDecoration = this.textarea.style.textDecoration;

          return div;
        };

        mxCellEditor.prototype.getMinimumSize = function (state) {
          const scale = this.graph.getView().scale;

          return new mxRectangle(0, 0, state.text == null ? 30 : state.text.size * scale + 20, 30);
        };

        const mxCellEditorGetCurrentHtmlValue = mxCellEditor.prototype.getCurrentHtmlValue;

        mxCellEditor.prototype.getCurrentHtmlValue = function () {
          if (this.textarea.style.display == 'none' && this.text2 != null) {
            return this.getCurrentValue();
          } else {
            return mxCellEditorGetCurrentHtmlValue.apply(this, arguments);
          }
        };

        // Workaround for focusLost calls stopEditing when in HTML view
        const mxCellEditorFocusLost = mxCellEditor.prototype.focusLost;

        mxCellEditor.prototype.focusLost = function (evt) {
          if (this.text2 == null) {
            mxCellEditorFocusLost.apply(this, arguments);
          }
        };
      }

      function createHint() {
        const hint = document.createElement('div');

        hint.className = 'geHint';
        hint.style.whiteSpace = 'nowrap';
        hint.style.position = 'absolute';

        return hint;
      }

      /**
       * Updates the hint for the current operation.
       */
      mxGraphHandler.prototype.updateHint = function (me) {
        if (this.shape != null) {
          if (this.hint == null) {
            this.hint = createHint();
            this.graph.container.appendChild(this.hint);
          }

          const t = this.graph.view.translate;
          const s = this.graph.view.scale;
          const x = this.roundLength((this.bounds.x + this.currentDx) / s - t.x);
          const y = this.roundLength((this.bounds.y + this.currentDy) / s - t.y);

          this.hint.innerHTML = x + ', ' + y;

          this.hint.style.left =
            this.shape.bounds.x +
            Math.round((this.shape.bounds.width - this.hint.clientWidth) / 2) +
            'px';
          this.hint.style.top = this.shape.bounds.y + this.shape.bounds.height + 12 + 'px';
        }
      };

      /**
       * Function: mouseDown
       *
       * Redirects the given event to the handlers.
       */
      mxSelectionCellsHandler.prototype.mouseDown = function (sender, me) {
        const cell = me.getCell();
        const evt = me.getEvent();
        const graph = this.graph;

        // Logic of selecting cells in view mode moved here
        // Because `graph.click` has been triggered on any `mouseup` and cause redundant selection resets
        if (!graph.isEnabled()) {
          if (cell) {
            let target;

            if (isImage(cell)) {
              target = _.find(diagramJsonSvc.get().images, {mxKey: +cell.id});
            }

            if (isText(cell)) {
              target = _.find(diagramJsonSvc.get().texts, {mxKey: +cell.id});
            }

            if ((target || {}).link) {
              navSvc.navigateByUrl(target.link);
            }

            if (!isActivity(cell) || !isSticker(cell)) {
              graph.clearSelection();
            }

            if (isActivity(cell)) {
              graph.selectCellForEvent(cell, evt);
            }

            if (isSticker(cell) && stickersSvc.canForceEdit(cell)) {
              graph.selectCellForEvent(cell, evt);
            }
          } else {
            graph.clearSelection();
          }
        }

        const args = [sender, me];

        this.handlers.visit(function (key, handler) {
          handler.mouseDown.apply(handler, args);
        });
      };

      /**
       * Function: mouseMove
       *
       * Redirects the given event to the handlers.
       */
      mxSelectionCellsHandler.prototype.mouseMove = function (sender, me) {
        if (this.isEnabled()) {
          const args = [sender, me];

          this.handlers.visit(function (key, handler) {
            handler.mouseMove.apply(handler, args);
          });
        }
      };

      /**
       * Function: mouseUp
       *
       * Redirects the given event to the handlers.
       */
      mxSelectionCellsHandler.prototype.mouseUp = function (sender, me) {
        if (this.isEnabled()) {
          const args = [sender, me];

          this.handlers.visit(function (key, handler) {
            handler.mouseUp.apply(handler, args);
          });
        }
      };

      /**
       * Updates the hint for the current operation.
       */
      mxGraphHandler.prototype.removeHint = function () {
        if (this.hint != null) {
          this.hint.parentNode.removeChild(this.hint);
          this.hint = null;
        }
      };

      mxGraphHandler.prototype.mouseDown = function (sender, me) {
        if (me.evt.target && me.evt.target.classList.contains('drag-item-handle')) {
          if (mxClient.IS_IE11) {
            return;
          } else {
            me.consume();
          }
        }

        const cell = this.getInitialCellForEvent(me);
        const enabledOrSticker =
          (isSticker(cell) && stickersSvc.canForceEdit(cell)) ||
          (this.isEnabled() && this.graph.isEnabled());

        if (
          !me.isConsumed() &&
          enabledOrSticker &&
          me.getState() != null &&
          !mxEvent.isMultiTouchEvent(me.getEvent())
        ) {
          this.delayedSelection = this.isDelayedSelection(cell, me);
          this.cell = null;

          if (this.isSelectEnabled() && !this.delayedSelection) {
            this.graph.selectCellForEvent(cell, me.getEvent());
          }

          if (this.isMoveEnabled()) {
            const model = this.graph.model;
            const geo = model.getGeometry(cell);

            if (
              this.graph.isCellMovable(cell) &&
              (!model.isEdge(cell) ||
                this.graph.getSelectionCount() > 1 ||
                (geo.points != null && geo.points.length > 0) ||
                model.getTerminal(cell, true) == null ||
                model.getTerminal(cell, false) == null ||
                this.graph.allowDanglingEdges ||
                (this.graph.isCloneEvent(me.getEvent()) && this.graph.isCellsCloneable()))
            ) {
              this.start(cell, me.getX(), me.getY());
            } else if (this.delayedSelection) {
              this.cell = cell;
            }

            this.cellWasClicked = true;
            me.consume();
          }
        }
      };

      const oldMouseUp = mxGraphHandler.prototype.mouseUp;

      mxGraphHandler.prototype.mouseUp = function (sender, me) {
        if (me.evt.target && me.evt.target.classList.contains('drag-item-handle')) {
          if (mxClient.IS_IE11) {
            return;
          } else {
            me.consume();
          }
        }

        oldMouseUp.call(this, sender, me);
      };

      /**
       * Enables recursive resize for groups.
       */
      mxVertexHandler.prototype.isRecursiveResize = function (state, me) {
        return (
          !this.graph.isSwimlane(state.cell) &&
          this.graph.model.getChildCount(state.cell) > 0 &&
          !mxEvent.isControlDown(me.getEvent()) &&
          !this.graph.isCellCollapsed(state.cell) &&
          mxUtils.getValue(state.style, 'recursiveResize', '1') == '1' &&
          mxUtils.getValue(state.style, 'childLayout', null) == null
        );
      };

      /**
       * Updates the hint for the current operation.
       */
      mxVertexHandler.prototype.updateHint = function (me) {
        if (this.index != mxEvent.LABEL_HANDLE) {
          if (this.hint == null) {
            this.hint = createHint();
            this.state.view.graph.container.appendChild(this.hint);
          }

          if (this.index == mxEvent.ROTATION_HANDLE) {
            this.hint.innerHTML = this.currentAlpha + '&deg;';
          } else {
            const s = this.state.view.scale;
            let w = this.roundLength(this.bounds.width / s);
            let h = this.roundLength(this.bounds.height / s);
            const minWidth = this.state.style.minWidth;
            const minHeight = this.state.style.minHeight;

            if (minWidth && w <= minWidth) {
              w = minWidth;
            }

            if (minHeight && h <= minHeight) {
              h = minHeight;
            }

            this.hint.innerHTML = w + ' x ' + h;
          }

          const rot =
            this.currentAlpha != null
              ? this.currentAlpha
              : this.state.style[mxConstants.STYLE_ROTATION] || '0';
          let bb = mxUtils.getBoundingBox(this.bounds, rot);

          if (bb == null) {
            bb = this.bounds;
          }

          this.hint.style.left = bb.x + Math.round((bb.width - this.hint.clientWidth) / 2) + 'px';
          this.hint.style.top = bb.y + bb.height + 12 + 'px';
        }
      };

      /**
       * Updates the hint for the current operation.
       */
      mxVertexHandler.prototype.removeHint = mxGraphHandler.prototype.removeHint;

      /**
       * Updates the hint for the current operation.
       */
      mxEdgeHandler.prototype.updateHint = function (me, point) {
        if (this.hint == null) {
          this.hint = createHint();
          this.state.view.graph.container.appendChild(this.hint);
        }

        const t = this.graph.view.translate;
        const s = this.graph.view.scale;
        const x = this.roundLength(point.x / s - t.x);
        const y = this.roundLength(point.y / s - t.y);

        this.hint.innerHTML = x + ', ' + y;
        this.hint.style.visibility = 'visible';

        if (this.isSource || this.isTarget) {
          if (
            this.constraintHandler.currentConstraint != null &&
            this.constraintHandler.currentFocus != null
          ) {
            const pt = this.constraintHandler.currentConstraint.point;

            flowlineHelperSvc.getClosestSide(pt.x, pt.y);
            this.hint.innerHTML =
              '[' + Math.round(pt.x * 100) + '%, ' + Math.round(pt.y * 100) + '%]';
          } else if (this.marker.hasValidState()) {
            this.hint.style.visibility = 'hidden';
          }
        }

        this.hint.style.left = Math.round(me.getGraphX() - this.hint.clientWidth / 2) + 'px';
        this.hint.style.top = me.getGraphY() + 12 + 'px';

        if (this.hideEdgeHintThread != null) {
          clearTimeout(this.hideEdgeHintThread);
        }

        this.hideEdgeHintThread = setTimeout(
          mxUtils.bind(this, function () {
            if (this.hint != null) {
              this.hint.style.visibility = 'hidden';
            }
          }),
          500
        );
      };

      /**
       * Updates the hint for the current operation.
       */
      mxEdgeHandler.prototype.removeHint = mxGraphHandler.prototype.removeHint;

      /**
       * Defines the handles for the UI. Uses data-URIs to speed-up loading time where supported.
       */
      const connectHandle = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABLZJREFUeNqcVl1MHFUUPrPMsn8s7UItthFa/ImNRB7aIC0aWyQhpqZWTBMNkQc3PvjiQ4MR05honyQmpjE8mmw01EqMwQcIopYAdUNR0CYYsk37oMIGuru1rEt2Z3Zm7lzPnbl3dlgXqE5ysnfPved85++ecyW4v0/aaZPit6OwJO2oQOLkcf16XKBMuVlGFUG3AxK8Kk5eJLm/v39vNBo9UVtb20gIUTc2NpJDQ0MLsVhsE/d1JAOJcNoCyIAqgTCrq5GCSHVra2vvFQqFON3my+fzs8lk8jyejXAZr/CcYVWKqhskPDExcRyVXBcKVYPSpb8pnUqZNH7XpIkcpRopAaIx06Ojo0dRtobrcMDKk8w2ZCTf1NTUsc7Ozgl0ObCuAHyxSuD7eyYopmRLUFuyFiVO7/PAqw95oN6HMSMkPTs7e66rq+sGniiycDIj3DmSeD58k5OTrd3d3TO4Wf1j2oSLt3RQTVuz2yoMisPZI0tw8XEZjtV7GFhubGzsuZ6engRuaTxnVHJ5w2IbUhTlB7/ff3R6ncCFhMbNt21xwiAJ21gO7KWMzI+e8EJHgwwYxmuhUOgl3ClwMOouXW8qlXqbgfy5acIHSwUwNQOJcDKA6sSiEs+0/xcJaKoB7y+pkFFMCAaDz2KBRHkqqoQnjkdYul3sTyyhQL5ogIHKjSInzaafng9bZGg6JwOIbtM9RYfLN1VLYSQS6eFRsu6jAzQ8PNyE3jyVK5owvlqwFTDluuGsGYmPuHhu+ur3PCgGZV49PTAwEBHOOEAdHR0n2GIppYGKlglPSJEDqvZ/8elq6YybNhUDbv+lWWf6+vraBIYsXKupqTnEGGs5DRUTdrWtG81yfTPa+K9Lt/zaQWd9JLbqrhm4kzOgtcEH4XC4SVwhWRw2TdMyQ0YBDa21SouVlCTt2nE17qm4Yh6OilVKxBmZ71Es6xRj1PmlLSFim02Xbjnmrpx/zFo1XbpdKn1hFD+zL2BnJJvNJsUh4ZE5Pz8/19zcDK0HsV1h6HQmSLcfFHpRdzqEsIjh7ZE9cKQhYLFGRkYWRVcXxWD29vauoFcLdaEqONMYwEpDMCwCh4o2lYC28tmahfDlh4Pg90qAuuKDg4MbAsjxiMliE70WCATa3jq1H75ObGBvo+7hZrWc2gu/Wl5QUSxO05QgjK3ozZP7Rdi+46ODlrcg1nFDqqpO+3y+J6/E78Ab36zwyiv1OgolxaLfCXO+fOUwnG17gLWgeWxBLyArz2eV6XHlnKGry8vL7zJG7zMPwqdnG8FDsGtjGBVsNQWd/ZoWWWvkFzBkfkLg8rlDFghTuri4+A7v3kQUQ8UxgYVxsr29fYwxf/sjBx+PrcDniayrgG1RP3r7eute6H/xMDxyIGhxZ2ZmunDELHAgXYyJ8sFnjQo2+NCq0xjGhBhsa3dV+u1Cmn52dZVemU7SqzcyNJ0tOoMPk/9LPB4/xWS5ji2Dr9KUrRL5QqrPZDKfYMwXtxvlCPBzOp3+kJ3lMtWVRrm0y+tH5h3YOz4+/mhLS8txrMoDKKwh+Prc3Nx17GcrPOE6z4nJ3yb0/zy3PNxTaZfnFv0vz62dHo/l5+n9PCIZ0D8CDACEWhv+nM/wTwAAAABJRU5ErkJggg=='
          : IMAGE_PATH + '/handle-connect.png',
        26,
        26
      );
      const mainHandle = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAAsTAAALEwEAmpwYAAABLUlEQVQ4y61US4rCQBBNeojiRrLSnbMOWWU3V1FPouARcgc9hyLOCSSbYZw5gRCIkM9KbevJaycS4zCOBY+iq6pf1y+xrNtiE6oEY/tVzMUXgSNoCJrUDu3qHpldutwSuIKOoEvt0m7I7DoCvNj2fb8XRdEojuN5lmVraJxhh59xFSLFF9phGL7lef6hRb63R73aHM8aAjv8JHJ47yqLlud5r0VRbHa51sPZQVuT/QU4ww4/4ljaJRubrC5SxouD6TWBQV/sEIkbs0eOIVGssSO1L5D6LQID+BHHZjdMSYpj7KZpun7/uk8CP5rNqTXLJP/OpNyTMWruP9CTP08nCILKdCp7gkCzJ8vPnz2BvW5PKhuLjJBykiQLaWIEjTP3o3Zjn/LtPO0rfvh/cgKu7z6wtPPltQAAAABJRU5ErkJggg=='
          : IMAGE_PATH + '/handle-main.png',
        17,
        17
      );
      const fixedHandle = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NkE1NkU4Njk2QjI1MTFFNEFDMjFGQTcyODkzNTc3NkYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NkE1NkU4NkE2QjI1MTFFNEFDMjFGQTcyODkzNTc3NkYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2QTU2RTg2NzZCMjUxMUU0QUMyMUZBNzI4OTM1Nzc2RiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2QTU2RTg2ODZCMjUxMUU0QUMyMUZBNzI4OTM1Nzc2RiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pmuk6K8AAAGBSURBVHjarFRBSsNQEM3/atNs6qLowixcKELoqjuXoqfQeoF6BMEj9BCC1YIXcCGlV8hGLNZlBKWlCk1JSs13Xvw/nca6UDrwmMzMy8tk/iTCWmwi52Eq53+QeWwg2bXSSNi1WiRibgRWCTahwEQmhJgw1WJGML2BC6wQnEqlsuH7fr3f7zdHo9EdPGLkUdc8mX8TJNYIpUajsR+G4YMie3pNVKebpB6GPOrgab7kr5F24Hne9ng87r6HStUuP5V1Mc2AGHnUwWMdCck6sVut1onjOHtnt4nV7M0fAuI65VEnXk3PTFq5Eyi4rnvUe1PW9fO3QOdUzvkbyqNOvEM2dMEHK2zbLr98zJ5+cJWkAvDGUC8Wi2X28Gww6bnHcTzYWp+JGAHTCQz1KIoGfFckCyZBELR3N4V1vCOyTrhHHnXw9N5kQn8+nWq1Onc6C/cERLMn7cfZniD/257wbjDxEjqiDT0fDof3tLE+PGK9HyXNy7pYyrez9K/43/+TLwEGAMb7AY6w980DAAAAAElFTkSuQmCC'
          : IMAGE_PATH + '/handle-fixed.png',
        17,
        17
      );
      const secondaryHandle = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEJBMUVERjNEMkZDMTFFM0I0Qzc5RkE1RTc2NjI0OUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEJBMUVERjREMkZDMTFFM0I0Qzc5RkE1RTc2NjI0OUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowQkExRURGMUQyRkMxMUUzQjRDNzlGQTVFNzY2MjQ5QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowQkExRURGMkQyRkMxMUUzQjRDNzlGQTVFNzY2MjQ5QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvXDOj4AAAFqSURBVHjarFTNToNAEN5FLeiBmDRe7MGLF4IXbp71KapP4CPoO/QdvKiv4ME0PkAvJI2J0SueIHgAAk3b7XxkwSlgE38mmSwz8+3HsPMtUnSbbKww1VhbYB5XbrBnpX3JnlUXSbURvk1ukvcYyYy8IJ9rsoqw3MAJtsh3Xdc98H3/KgzDuyRJHrEiRh51jTOaX4LEDrk9Go1O0zR9UWTL9E0to+dyhSGPOnAab/DPKDtwHOcoy7LXz1SpxeRSzW9F7YiRRx041pGsSMC6Ty1f442LycUawRfRsOyIcDfA632ST6A3GAzOVfYu1PS+c+5q+iBQJ9wZO3TJD1aaptkX+YfYaFS3LKvPXl4fTDn3oigiYR1uJqF6nucR14rBglkQBGO5dyzkybBbxpRHHTitm5rox9PxPK81nZZOAKx1Eo5rnSD/nU54NzhxGx1hjHEcP5FifayItT5sjVvTyJ/vzr/f4l//T1YCDAC4VAdLL1OIRAAAAABJRU5ErkJggg=='
          : IMAGE_PATH + '/handle-secondary.png',
        17,
        17
      );
      const rotationHandle = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,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'
          : IMAGE_PATH + '/handle-rotate.png',
        19,
        21
      );
      const triangleUp = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDA3RjREMDM0NTVCMTFFNEIxOTZFRjE3NzRENjQ0RjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDA3RjREMDQ0NTVCMTFFNEIxOTZFRjE3NzRENjQ0RjIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0MDdGNEQwMTQ1NUIxMUU0QjE5NkVGMTc3NEQ2NDRGMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0MDdGNEQwMjQ1NUIxMUU0QjE5NkVGMTc3NEQ2NDRGMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpFdYkUAAAEsSURBVHjaYvz//z8DPQATA50AC+P6D6Tq0QViHiA+TpJFZDhuMhDzA7EhLYMuEIjtgdgAiJNJ0cjIsO49sWo5gfgqECtC+S+AWBWIv1DbR0VIloCABBA3UttHIENvQxMBMvgFxNpAfIdaPurFYgkIsAFxF7WCzgyIowgkEA9qWDSZSB8zU2JRMtRHhIAWEKeRmxh4oAlAgsh4fAdN7u9I9VEFCZaAgBAQt5DqIxVo5mQjseT4C8R6QHyNWB91kWEJAzRBTCA26JygSZZc4IpNPxMWF01moBxghAi6RWnQpEopAMVxPq7EIARNzkJUqlS/QJP7C3QftVDRElg+bEH3ESi4LhEqRsgEoJr4AhNSeUYLS0BgJqzNACrLRIH4Mo0sAtXM9ozDrl0HEGAAOt00sQRg5yAAAAAASUVORK5CYII='
          : IMAGE_PATH + '/triangle-up.png',
        26,
        26
      );
      const triangleRight = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RkQ3OEM2Nzg0NTVBMTFFNEIxOTZFRjE3NzRENjQ0RjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RkQ3OEM2Nzk0NTVBMTFFNEIxOTZFRjE3NzRENjQ0RjIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGRDc4QzY3NjQ1NUExMUU0QjE5NkVGMTc3NEQ2NDRGMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGRDc4QzY3NzQ1NUExMUU0QjE5NkVGMTc3NEQ2NDRGMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmADGesAAAE2SURBVHjatJaxSgNBFEU3iQhCQEllK1hFItjsB1jYr6WtgigIAcFGwSafIBaipa1pBRG0Eq0koI1+QCqxSCXIekbug2UhGJN5Fw7Dzi4c5s283a3keZ6EVLqfKcNTEjl5Nvc7Vgtz53ALzcQh1dL1KvTgFBqeopAa7MCbxpqXyNLQynpaqZvI0tTeXcGip8iSwQt0oO4pCpmGQ+3fpqfIMq92eITUU2RJJbuU3E1k2VA5Q1lnPEWJDkhHBybzFFkW1Ap30PIUWWaLbeAh6sMWrMCDTU5FFHzBCRzDoHwzlqgLB/A+7IFJRa+wD9deDfsBu7A8imScFX3DGRxJNnL+I7qBtsrl8pkIG7wOa+NK/hINdJKWdKomyrDSXWgf+rGarCwK/3Xb8Bz7dVEU7cG914vvR4ABAGCSNhcpqHjLAAAAAElFTkSuQmCC'
          : IMAGE_PATH + '/triangle-right.png',
        26,
        26
      );
      const triangleDown = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RkQ3OEM2N0M0NTVBMTFFNEIxOTZFRjE3NzRENjQ0RjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RkQ3OEM2N0Q0NTVBMTFFNEIxOTZFRjE3NzRENjQ0RjIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGRDc4QzY3QTQ1NUExMUU0QjE5NkVGMTc3NEQ2NDRGMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGRDc4QzY3QjQ1NUExMUU0QjE5NkVGMTc3NEQ2NDRGMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuktDIwAAAE0SURBVHjaYvz//z8DPQATA50AC+P6D/ZAejKN7UlhARIHgfg7EJvRyJJ9QHwKFnTpNLLkLxDnIsfRBSCeSwOLZgHxNRCDkWHde5igBBDfBmIeKlnyDohVoTRKqnsBxE1U9E0NzBJ0H4EAGxBfBWIVCi0BBZceNI6w5qNfQFxGBd/kIluCK8OuB+LdFFiyHpqkiSoZCtBdRCTAGSJMeMJ4FhkWdQPxHWwS6IkBGQhBk7sQkZa8gCbnL6QWqu+gSZSU5PyF3NIbnrMJgFOEShYmIsqqYiKTM8X10Q5oksUFlkF9RJWKrwyadNHBFyJ9TLRFoCQ7BYt4BzS1EQT4kjc64IEmdwko/z4Qa0MrTaq2Gb6gJfdiYi0h1UcwcB6IPwKxA0mNEzKKmSx8GROnj4Zduw4gwAC3tEnG5i1iXgAAAABJRU5ErkJggg=='
          : IMAGE_PATH + '/triangle-down.png',
        26,
        26
      );
      const triangleLeft = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDA3RjRDRkY0NTVCMTFFNEIxOTZFRjE3NzRENjQ0RjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDA3RjREMDA0NTVCMTFFNEIxOTZFRjE3NzRENjQ0RjIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGRDc4QzY3RTQ1NUExMUU0QjE5NkVGMTc3NEQ2NDRGMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0MDdGNENGRTQ1NUIxMUU0QjE5NkVGMTc3NEQ2NDRGMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PquyPQ0AAAE+SURBVHjatJaxSgNBFEU3KoKQQqzyAdoohFSKlQERbGNrqVik8QeCVdIIgpVBMK2lW9oF0qYRFFMJtlZBQRAEWc/AHVklxE123oUDm+zA4b03s0whSZLIpRC/RgbZSmqLPfcwF9mkApewAGX3x0xgQQmu4A7W0y9CVTQPx3ACxVELQohqcArL4xblEa3COexkWTzNjJbgAu6zSiataBaOoCnZRMkq2oUztWuq/Nc6N+AbuM0jGScqqoJH7arcGdW6A82hFPIkp0Wb2k0Vi29SunXv8Gb07fsleoAq7MGzpcgnhjVoqEozkcsHtGAFri1FPi+wDxvQtxT59CU7lNxM5NNRO11bPy1F/hg0tGFiS5HPk47CNgwsRT5dXUDqMLQUuXxBW/Nr67eJyGeoysqqNPgt6G8Gmt3PletbgAEAmkYzZ9MOuCsAAAAASUVORK5CYII='
          : IMAGE_PATH + '/triangle-left.png',
        26,
        26
      );
      const refreshTarget = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,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'
          : IMAGE_PATH + '/refresh.png',
        38,
        38
      );
      const roundDrop = new mxImage(
        mxClient.IS_SVG
          ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTgxRjYzRTU1MDRFMTFFNEExQ0VFNDQwNDhGNzg2RDkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTgxRjYzRTY1MDRFMTFFNEExQ0VFNDQwNDhGNzg2RDkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFODFGNjNFMzUwNEUxMUU0QTFDRUU0NDA0OEY3ODZEOSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFODFGNjNFNDUwNEUxMUU0QTFDRUU0NDA0OEY3ODZEOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuJ657wAAAE0SURBVHjaYvz//z8DPQATA50AC4zBuP4DLjXaQOwMxJZArAfE8lDxh0B8CYiPA/FeIL6KTfP/QAFUi7AABSBOAOJoIFbBIq8FxRFAfAeIlwLxAiB+gNdHaMABiIuB2IfIkAE5pB6IjYG4F4gPEBNHIEtaSLAEGfhA9ToQskgB6hNrCuLdGmqGAj6LEsj0CTafJeCySBsa8dQC0VAzMSxyxpG6yAUqUDMxLLKkQT61xGaRHg0s0sNmkTwNLJKne1mHbNFDGpj/EJtFl2hg0SVsFh2ngUXHsVm0F1oKUwvcgZqJYdFVaFFPLbAUuY5CT3Wg+mQLFSzZAjULZ6H6AFqfHKXAkqNQMx4Qqo9AlVYNmT7bAtV7gNga9gDURWfxVOXoEY+3KmeENbdo3ThhHHbtOoAAAwDmEETshQ0fBAAAAABJRU5ErkJggg=='
          : IMAGE_PATH + '/round-drop.png',
        26,
        26
      );

      // Pre-fetches images (only needed for non data-uris)
      if (!mxClient.IS_SVG) {
        new Image().src = connectHandle.src;
        new Image().src = mainHandle.src;
        new Image().src = fixedHandle.src;
        new Image().src = secondaryHandle.src;
        new Image().src = rotationHandle.src;
        new Image().src = triangleUp.src;
        new Image().src = triangleRight.src;
        new Image().src = triangleDown.src;
        new Image().src = triangleLeft.src;
        new Image().src = roundDrop.src;
      }

      mxConnectionHandler.prototype.connectImage = connectHandle;
      mxVertexHandler.prototype.handleImage = mainHandle;
      mxVertexHandler.prototype.secondaryHandleImage = secondaryHandle;
      mxEdgeHandler.prototype.handleImage = mainHandle;
      mxEdgeHandler.prototype.fixedHandleImage = fixedHandle;
      mxEdgeHandler.prototype.labelHandleImage = secondaryHandle;
      mxOutline.prototype.sizerImage = mainHandle;

      // Adds rotation handle and live preview
      mxVertexHandler.prototype.rotationEnabled = true;
      mxVertexHandler.prototype.manageSizers = true;
      mxVertexHandler.prototype.livePreview = false;

      // Increases default rubberband opacity (default is 20)
      mxRubberband.prototype.defaultOpacity = 30;

      // Enables connections along the outline, virtual waypoints, parent highlight etc
      mxConnectionHandler.prototype.outlineConnect = true;
      mxCellHighlight.prototype.keepOnTop = true;
      mxCellHighlight.prototype.spacing = 2;
      mxVertexHandler.prototype.parentHighlightEnabled = true;
      mxVertexHandler.prototype.rotationHandleVSpacing = -20;

      mxEdgeHandler.prototype.parentHighlightEnabled = true;
      mxEdgeHandler.prototype.dblClickRemoveEnabled = true;
      mxEdgeHandler.prototype.straightRemoveEnabled = true;
      mxEdgeHandler.prototype.virtualBendsEnabled = true;
      mxEdgeHandler.prototype.mergeRemoveEnabled = true;
      mxEdgeHandler.prototype.manageLabelHandle = false;
      mxEdgeHandler.prototype.outlineConnect = true;

      // Disables adding waypoints if shift is pressed
      mxEdgeHandler.prototype.isAddVirtualBendEvent = function (me) {
        return !mxEvent.isShiftDown(me.getEvent());
      };

      // Disables custom handles if shift is pressed
      mxEdgeHandler.prototype.isCustomHandleEvent = function (me) {
        return !mxEvent.isShiftDown(me.getEvent());
      };

      // Timer-based activation of outline connect in connection handler
      let startTime = new Date().getTime();
      let timeOnTarget = 0;

      /**
       * Function: getPreviewPoints
       *
       * Updates the given preview state taking into account the state of the constraint handler.
       *
       * Parameters:
       *
       * pt - <mxPoint> that contains the current pointer position.
       * me - Optional <mxMouseEvent> that contains the current event.
       */
      mxEdgeHandler.prototype.getPreviewPoints = function (pt, me) {
        const geometry = this.graph.getCellGeometry(this.state.cell);
        let points = geometry.points != null ? geometry.points.slice() : null;
        const point = new mxPoint(pt.x, pt.y);
        let result = null;

        if (me.state && me.state.cell && isActivity(me.state.cell)) {
          const edge = this.state.cell;
          const cell = me.state.cell;
          const constraint = this.graph.getOutlineConstraint(point, me.state, me);

          if (this.isTarget) {
            if (!edge.target) {
              return null;
            } else if (edge.target.id != me.state.cell.id) {
              return null;
            }

            return flowlineHelperSvc.getSmartWp(edge, constraint, points, cell, false);
          }

          if (this.isSource) {
            if (!edge.source) {
              return null;
            } else if (edge.source.id != me.state.cell.id) {
              return null;
            }

            return flowlineHelperSvc.getSmartWp(edge, constraint, points, cell, true);
          }
        }

        if (!this.isSource && !this.isTarget) {
          this.convertPoint(point, false);

          if (points == null) {
            points = [point];
          } else {
            // Adds point from virtual bend
            if (this.index <= mxEvent.VIRTUAL_HANDLE) {
              points.splice(mxEvent.VIRTUAL_HANDLE - this.index, 0, point);
            }

            // Removes point if dragged on terminal point
            if (!this.isSource && !this.isTarget) {
              for (let i = 0; i < this.bends.length; i++) {
                if (i != this.index) {
                  const bend = this.bends[i];

                  if (bend != null && mxUtils.contains(bend.bounds, pt.x, pt.y)) {
                    if (this.index <= mxEvent.VIRTUAL_HANDLE) {
                      points.splice(mxEvent.VIRTUAL_HANDLE - this.index, 1);
                    } else {
                      points.splice(this.index - 1, 1);
                    }

                    result = points;
                  }
                }
              }

              // Removes point if user tries to straighten a segment
              if (
                result == null &&
                this.straightRemoveEnabled &&
                (me == null || !mxEvent.isAltDown(me.getEvent()))
              ) {
                const tol = this.graph.tolerance * this.graph.tolerance;
                const abs = this.state.absolutePoints.slice();

                abs[this.index] = pt;

                // Handes special case where removing waypoint affects tolerance (flickering)
                const src = this.state.getVisibleTerminalState(true);

                if (src != null) {
                  const c = this.graph.getConnectionConstraint(this.state, src, true);

                  // Checks if point is not fixed
                  if (c == null || this.graph.getConnectionPoint(src, c) == null) {
                    abs[0] = new mxPoint(
                      src.view.getRoutingCenterX(src),
                      src.view.getRoutingCenterY(src)
                    );
                  }
                }

                const trg = this.state.getVisibleTerminalState(false);

                if (trg != null) {
                  const c = this.graph.getConnectionConstraint(this.state, trg, false);

                  // Checks if point is not fixed
                  if (c == null || this.graph.getConnectionPoint(trg, c) == null) {
                    abs[abs.length - 1] = new mxPoint(
                      trg.view.getRoutingCenterX(trg),
                      trg.view.getRoutingCenterY(trg)
                    );
                  }
                }

                // LATER: Check if other points can be removed if a segment is made straight
                checkRemove(abs, tol, this.index, pt);
              }
            }

            // Updates existing point
            if (result == null && this.index > mxEvent.VIRTUAL_HANDLE) {
              points[this.index - 1] = point;
            }
          }
        } else if (this.graph.resetEdgesOnConnect) {
          points = null;
        }

        function checkRemove(abs, tol, idx, tmp) {
          if (
            idx > 0 &&
            idx < abs.length - 1 &&
            mxUtils.ptSegDistSq(
              abs[idx - 1].x,
              abs[idx - 1].y,
              abs[idx + 1].x,
              abs[idx + 1].y,
              tmp.x,
              tmp.y
            ) < tol
          ) {
            points.splice(idx - 1, 1);
            result = points;
          }
        }

        return result != null ? result : points;
      };

      /**
       * Function: updateCurrentState
       *
       * Updates the current state for a given mouse move event by using
       * the <marker>.
       */
      mxConnectionHandler.prototype.updateCurrentState = function (me, point) {
        this.constraintHandler.update(
          me,
          this.first == null,
          false,
          this.first == null || me.isSource(this.marker.highlight.shape) ? null : point
        );

        if (
          this.constraintHandler.currentFocus != null &&
          this.constraintHandler.currentConstraint != null
        ) {
          // Handles special case where grid is large and connection point is at actual point in which
          // case the outline is not followed as long as we're < gridSize / 2 away from that point
          if (
            this.marker.highlight != null &&
            this.marker.highlight.state != null &&
            this.marker.highlight.state.cell == this.constraintHandler.currentFocus.cell
          ) {
            // Direct repaint needed if cell already highlighted
            if (this.marker.highlight.shape.stroke != 'transparent') {
              this.marker.highlight.shape.stroke = 'transparent';
              this.marker.highlight.repaint();
            }
          } else {
            this.marker.markCell(this.constraintHandler.currentFocus.cell, 'transparent');
          }

          // Updates validation state
          if (this.previous != null) {
            this.error = this.validateConnection(
              this.previous.cell,
              this.constraintHandler.currentFocus.cell
            );

            if (this.error == null) {
              this['currentState'] = this.constraintHandler.currentFocus;
            } else {
              this.constraintHandler.reset();
            }
          }
        } else {
          if (this.graph.isIgnoreTerminalEvent(me.getEvent())) {
            this.marker.reset();
            this['currentState'] = null;
          } else {
            this.marker.process(me);
            this['currentState'] = this.marker.getValidState();
          }

          const outline = this.isOutlineConnectEvent(me);

          if (this.currentState != null && outline) {
            // Handles special case where mouse is on outline away from actual end point
            // in which case the grid is ignored and mouse point is used instead
            if (me.isSource(this.marker.highlight.shape)) {
              point = new mxPoint(me.getGraphX(), me.getGraphY());
            }

            const constraint = this.graph.getOutlineConstraint(point, this.currentState, me);

            if (constraint.point) {
              constraint.point = flowlineHelperSvc.getClosestSide(
                constraint.point.x,
                constraint.point.y
              );
            }

            this.constraintHandler.setFocus(me, this.currentState, false);
            this.constraintHandler.currentConstraint = constraint;
            this.constraintHandler.currentPoint = point;
          }

          if (this.outlineConnect) {
            if (this.marker.highlight != null && this.marker.highlight.shape != null) {
              const s = this.graph.view.scale;

              if (
                this.constraintHandler.currentConstraint != null &&
                this.constraintHandler.currentFocus != null &&
                this.marker.hasValidState()
              ) {
                this.marker.highlight.shape.stroke = mxConstants.OUTLINE_HIGHLIGHT_COLOR;
                this.marker.highlight.shape.strokewidth =
                  mxConstants.OUTLINE_HIGHLIGHT_STROKEWIDTH / s / s;
                this.marker.highlight.repaint();
              } else if (this.marker.hasValidState()) {
                // Handles special case where actual end point of edge and current mouse point
                // are not equal (due to grid snapping) and there is no hit on shape or highlight
                if (this.marker.getValidState() != me.getState()) {
                  this.marker.highlight.shape.stroke = 'transparent';
                  this['currentState'] = null;
                } else {
                  this.marker.highlight.shape.stroke = mxConstants.DEFAULT_VALID_COLOR;
                }

                this.marker.highlight.shape.strokewidth = mxConstants.HIGHLIGHT_STROKEWIDTH / s / s;
                this.marker.highlight.repaint();
              } else {
                this.marker.highlight.shape.stroke = mxConstants.DEFAULT_INVALID_COLOR;
                this.marker.highlight.shape.strokewidth =
                  mxConstants.OUTLINE_HIGHLIGHT_STROKEWIDTH / s / s;
                this.marker.highlight.repaint();
              }
            }
          }
        }
      };

      mxEdgeHandler.prototype.updatePreviewState = function (edge, point, terminalState, me) {
        if (terminalState != this.currentTerminalState) {
          startTime = new Date().getTime();
          timeOnTarget = 0;
        } else {
          timeOnTarget = new Date().getTime() - startTime;
        }

        this.currentTerminalState = terminalState;
        // Computes the points for the edge style and terminals
        const sourceState = this.isSource
          ? terminalState
          : this.state.getVisibleTerminalState(true);
        const targetState = this.isTarget
          ? terminalState
          : this.state.getVisibleTerminalState(false);

        let sourceConstraint = this.graph.getConnectionConstraint(edge, sourceState, true);
        let targetConstraint = this.graph.getConnectionConstraint(edge, targetState, false);

        let constraint = this.constraintHandler.currentConstraint;

        if (constraint == null) {
          if (terminalState != null && this.isOutlineConnectEvent(me)) {
            constraint = this.graph.getOutlineConstraint(point, terminalState, me);
            this.constraintHandler.currentConstraint = constraint;
            this.constraintHandler.currentFocus = terminalState;
            this.constraintHandler.currentPoint = point;
          } else {
            constraint = new mxConnectionConstraint();
          }
        }

        if (this.outlineConnect) {
          if (this.marker.highlight != null && this.marker.highlight.shape != null) {
            if (
              this.constraintHandler.currentConstraint != null &&
              this.constraintHandler.currentFocus != null &&
              this.marker.hasValidState()
            ) {
              this.marker.highlight.shape.stroke = mxConstants.OUTLINE_HIGHLIGHT_COLOR;
              this.marker.highlight.shape.strokewidth =
                mxConstants.OUTLINE_HIGHLIGHT_STROKEWIDTH /
                this.state.view.scale /
                this.state.view.scale;
              this.marker.highlight.repaint();
            } else if (this.marker.hasValidState()) {
              this.marker.highlight.shape.stroke = mxConstants.DEFAULT_VALID_COLOR;
              this.marker.highlight.shape.strokewidth =
                mxConstants.HIGHLIGHT_STROKEWIDTH / this.state.view.scale / this.state.view.scale;
              this.marker.highlight.repaint();
            } else if (
              !this.constraintHandler.currentConstraint ||
              !this.constraintHandler.currentConstraint.perimeter
            ) {
              this.marker.highlight.shape.stroke = mxConstants.DEFAULT_INVALID_COLOR;
              this.marker.highlight.shape.strokewidth =
                mxConstants.OUTLINE_HIGHLIGHT_STROKEWIDTH /
                this.state.view.scale /
                this.state.view.scale;
              this.marker.highlight.repaint();
            }
          }
        }

        if (constraint.point) {
          constraint.point = flowlineHelperSvc.getClosestSide(
            constraint.point.x,
            constraint.point.y
          );
        }

        if (this.isSource) {
          sourceConstraint = constraint;
        } else if (this.isTarget) {
          targetConstraint = constraint;
        }

        edge.setVisibleTerminalState(sourceState, true);
        edge.setVisibleTerminalState(targetState, false);

        if (!this.isSource || sourceState != null) {
          edge.view.updateFixedTerminalPoint(edge, sourceState, true, sourceConstraint);
        }

        if (!this.isTarget || targetState != null) {
          edge.view.updateFixedTerminalPoint(edge, targetState, false, targetConstraint);
        }

        if ((this.isSource || this.isTarget) && terminalState == null) {
          edge.setAbsoluteTerminalPoint(point, this.isSource);

          if (this.marker.getMarkedState() == null) {
            this.error = this.graph.allowDanglingEdges ? null : '';
          }
        }

        edge.view.updatePoints(edge, this.points, sourceState, targetState);
        edge.view.updateFloatingTerminalPoints(edge, sourceState, targetState);
      };

      // Timer-based outline connect
      //var mxEdgeHandlerIsOutlineConnectEvent = mxEdgeHandler.prototype.isOutlineConnectEvent;

      mxEdgeHandler.prototype.isOutlineConnectEvent = function (me) {
        return true;
      };

      // Disables custom handles if shift is pressed
      mxVertexHandler.prototype.isCustomHandleEvent = function (me) {
        return !mxEvent.isShiftDown(me.getEvent());
      };

      /**
       * Function: mouseUp
       *
       * Handles the event to applying the previewed changes on the edge by
       * using <moveLabel>, <connect> or <changePoints>.
       */
      mxEdgeHandler.prototype.mouseUp = function (sender, me) {
        // Workaround for wrong event source in Webkit
        if (this.index != null && this.marker != null) {
          let edge = this.state.cell;

          // Ignores event if mouse has not been moved
          if (me.getX() != this.startX || me.getY() != this.startY) {
            const clone =
              this.graph.isCloneEvent(me.getEvent()) &&
              this.cloneEnabled &&
              this.graph.isCellsCloneable();

            // Displays the reason for not carriying out the change
            // if there is an error message with non-zero length
            if (this.error != null) {
              if (this.error.length > 0) {
                this.graph.validationAlert(this.error);
              }
            } else if (this.index <= mxEvent.CUSTOM_HANDLE && this.index > mxEvent.VIRTUAL_HANDLE) {
              if (this.customHandles != null) {
                const model = this.graph.getModel();

                model.beginUpdate();

                try {
                  this.customHandles[mxEvent.CUSTOM_HANDLE - this.index].execute();
                } finally {
                  model.endUpdate();
                }
              }
            } else if (this.isLabel) {
              this.moveLabel(this.state, this.label.x, this.label.y);
            } else if (this.isSource || this.isTarget) {
              let terminal = null;

              if (
                this.constraintHandler.currentConstraint != null &&
                this.constraintHandler.currentFocus != null
              ) {
                terminal = this.constraintHandler.currentFocus.cell;
              }

              if (terminal == null && this.marker.hasValidState()) {
                terminal = this.marker.validState.cell;
              }

              if (terminal != null) {
                edge = this.connect(edge, terminal, this.isSource, clone, me);
              } else if (this.graph.isAllowDanglingEdges()) {
                const pt = this.abspoints[this.isSource ? 0 : this.abspoints.length - 1];

                pt.x = this.roundLength(pt.x / this.graph.view.scale - this.graph.view.translate.x);
                pt.y = this.roundLength(pt.y / this.graph.view.scale - this.graph.view.translate.y);

                const pstate = this.graph.getView().getState(this.graph.getModel().getParent(edge));

                if (pstate != null) {
                  pt.x -= pstate.origin.x;
                  pt.y -= pstate.origin.y;
                }

                pt.x -= this.graph.panDx / this.graph.view.scale;
                pt.y -= this.graph.panDy / this.graph.view.scale;

                // Destroys and recreates this handler
                edge = this.changeTerminalPoint(edge, pt, this.isSource, clone);
              }
            } else if (this.active) {
              edge = this.changePoints(edge, this.points, clone);
            } else {
              this.graph.getView().invalidate(this.state.cell);
              this.graph.getView().validate(this.state.cell);
            }
          }

          // Resets the preview color the state of the handler if this
          // handler has not been recreated
          if (this.marker != null) {
            this.reset();

            // Updates the selection if the edge has been cloned
            if (edge != this.state.cell) {
              this.graph.setSelectionCell(edge);
            }
          }

          me.consume();
        }
      };

      /**
       * Function: connect
       *
       * Changes the terminal or terminal point of the given edge in the graph
       * model.
       *
       * Parameters:
       *
       * edge - <mxCell> that represents the edge to be reconnected.
       * terminal - <mxCell> that represents the new terminal.
       * isSource - Boolean indicating if the new terminal is the source or
       * target terminal.
       * isClone - Boolean indicating if the new connection should be a clone of
       * the old edge.
       * me - <mxMouseEvent> that contains the mouse up event.
       */
      mxEdgeHandler.prototype.connect = function (edge, terminal, isSource, isClone, me) {
        const model = this.graph.getModel();
        const parent = model.getParent(edge);

        model.beginUpdate();

        try {
          // Clones and adds the cell
          if (isClone) {
            const clone = this.graph.cloneCells([edge])[0];

            model.add(parent, clone, model.getChildCount(parent));

            const other = model.getTerminal(edge, !isSource);

            this.graph.connectCell(clone, other, !isSource);

            edge = clone;
          }

          let constraint = this.constraintHandler.currentConstraint;

          if (constraint == null) {
            constraint = new mxConnectionConstraint();
          }

          if (constraint.point) {
            constraint.point = flowlineHelperSvc.getClosestSide(
              constraint.point.x,
              constraint.point.y
            );
          }

          this.graph.connectCell(edge, terminal, isSource, constraint);
        } finally {
          model.endUpdate();
        }

        return edge;
      };

      // Shows secondary handle for fixed connection points
      mxEdgeHandler.prototype.createHandleShape = function (index) {
        const source = index == 0;
        const c =
          index == 0 || index >= this.state.absolutePoints.length - 1
            ? this.graph.getConnectionConstraint(
                this.state,
                this.state.getVisibleTerminalState(source),
                source
              )
            : null;
        const pt =
          c != null
            ? this.graph.getConnectionPoint(this.state.getVisibleTerminalState(source), c)
            : null;
        const img = pt != null ? this.fixedHandleImage : this.handleImage;

        if (img != null) {
          const shape = new mxImageShape(new mxRectangle(0, 0, img.width, img.height), img.src);

          // Allows HTML rendering of the images
          shape.preserveImageAspect = false;

          return shape;
        } else {
          let s = mxConstants.HANDLE_SIZE;

          if (this.preferHtml) {
            s -= 1;
          }

          return new mxRectangleShape(
            new mxRectangle(0, 0, s, s),
            mxConstants.HANDLE_FILLCOLOR,
            mxConstants.HANDLE_STROKECOLOR
          );
        }
      };

      const vertexHandlerCreateSizerShape = mxVertexHandler.prototype.createSizerShape;

      mxVertexHandler.prototype.createSizerShape = function (bounds, index, fillColor) {
        this.handleImage =
          index == mxEvent.ROTATION_HANDLE
            ? rotationHandle
            : index == mxEvent.LABEL_HANDLE
              ? this.secondaryHandleImage
              : this.handleImage;

        return vertexHandlerCreateSizerShape.apply(this, arguments);
      };

      // Special case for single edge label handle moving in which case the text bounding box is used
      const mxGraphHandlerGetBoundingBox = mxGraphHandler.prototype.getBoundingBox;

      mxGraphHandler.prototype.getBoundingBox = function (cells) {
        if (cells != null && cells.length == 1) {
          const model = this.graph.getModel();
          const parent = model.getParent(cells[0]);
          const geo = this.graph.getCellGeometry(cells[0]);

          if (model.isEdge(parent) && geo != null && geo.relative) {
            const state = this.graph.view.getState(cells[0]);

            if (
              state != null &&
              state.width < 2 &&
              state.height < 2 &&
              state.text != null &&
              state.text.boundingBox != null
            ) {
              return mxRectangle.fromRectangle(state.text.boundingBox);
            }
          }
        }

        return mxGraphHandlerGetBoundingBox.apply(this, arguments);
      };

      // Uses text bounding box for edge labels
      const mxVertexHandlerGetSelectionBounds = mxVertexHandler.prototype.getSelectionBounds;

      mxVertexHandler.prototype.getSelectionBounds = function (state) {
        const model = this.graph.getModel();
        const parent = model.getParent(state.cell);
        const geo = this.graph.getCellGeometry(state.cell);

        if (
          model.isEdge(parent) &&
          geo != null &&
          geo.relative &&
          state.width < 2 &&
          state.height < 2 &&
          state.text != null &&
          state.text.boundingBox != null
        ) {
          const bbox = state.text.unrotatedBoundingBox || state.text.boundingBox;

          return new mxRectangle(
            Math.round(bbox.x),
            Math.round(bbox.y),
            Math.round(bbox.width),
            Math.round(bbox.height)
          );
        } else {
          return mxVertexHandlerGetSelectionBounds.apply(this, arguments);
        }
      };

      // Redirects moving of edge labels to mxGraphHandler by not starting here.
      // This will use the move preview of mxGraphHandler (see above).
      mxVertexHandler.prototype.mouseDown = function (sender, me) {
        const model = this.graph.getModel();
        const parent = model.getParent(this.state.cell);
        const geo = this.graph.getCellGeometry(this.state.cell);

        const tol = !mxEvent.isMouseEvent(me.getEvent()) ? this.tolerance : 0;
        const handle = this.getHandleForEvent(me);

        if (
          handle === mxEvent.ROTATION_HANDLE ||
          !model.isEdge(parent) ||
          geo == null ||
          !geo.relative ||
          this.state == null ||
          this.state.width >= 2 ||
          this.state.height >= 2
        ) {
          const cell = this.state?.cell;
          const enabledOrSticker =
            (isSticker(cell) && stickersSvc.canForceEdit(cell)) || this.graph.isEnabled();

          if (!me.isConsumed() && enabledOrSticker && (tol > 0 || me.getState() == this.state)) {
            if (handle != null) {
              this.start(me.getGraphX(), me.getGraphY(), handle);
              me.consume();
            }
          }
        }
      };

      // Shows rotation handle for edge labels.
      mxVertexHandler.prototype.isRotationHandleVisible = function () {
        return (
          this.rotationEnabled &&
          this.graph.isCellRotatable(this.state.cell) &&
          (mxGraphHandler.prototype.maxCells <= 0 ||
            this.graph.getSelectionCount() < mxGraphHandler.prototype.maxCells)
        );
      };

      // Invokes turn on single click on rotation handle
      mxVertexHandler.prototype.rotateClick = function () {
        //this.state.view.graph.turnShapes([this.state.cell]);
      };

      /**
       * Implements touch style
       */
      if (touchStyle) {
        // Larger tolerance for real touch devices
        // @ts-ignore
        if (mxClient.IS_TOUCH || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
          //      mxShape.prototype.svgStrokeTolerance = 18;
          //      mxVertexHandler.prototype.tolerance = 12;
          //      mxEdgeHandler.prototype.tolerance = 12;
          Graph.prototype.tolerance = 12;
        }
      }

      // Disables connection points
      const connectionHandlerInit = mxConnectionHandler.prototype.init;

      mxConnectionHandler.prototype.init = function () {
        connectionHandlerInit.apply(this, arguments);

        this.constraintHandler.isEnabled = mxUtils.bind(this, function () {
          return this.graph.connectionHandler.isEnabled();
        });
      };

      /** redraw methond of mxVertexHandler executes rendering of the selection box and rendering of handles (sizers)
      In view mode we don't want default selection to be rendered on activity though we allow selecting activity
      In case separate control of selection box and handles rendering will be needed, then consider changing
       mxVertexHandler.drawPreview and mxVertexHandler.redrawHandles separately */
      const vertexHandlerRedraw = mxVertexHandler.prototype.redraw;

      mxVertexHandler.prototype.redraw = function () {
        const cell = this.state?.cell;

        if (!this.graph.isEnabled() && isActivity(cell)) {
          return cell.comp?.instance.toggleHighlight(true);
        }

        return vertexHandlerRedraw.apply(this, arguments);
      };

      const vertexHandlerRedrawHandles = mxVertexHandler.prototype.redrawHandles;

      mxVertexHandler.prototype.redrawHandles = function () {
        vertexHandlerRedrawHandles.apply(this);

        if (this.state != null && this.connectorImg != null) {
          let pt = new mxPoint();
          const s = this.state;

          // Top right for single-sizer
          if (mxVertexHandler.prototype.singleSizer) {
            pt.x = s.x + s.width - this.connectorImg.offsetWidth / 2;
            pt.y = s.y - this.connectorImg.offsetHeight / 2;
          } else {
            const dx = this.handleImage != null ? this.handleImage.width : mxConstants.HANDLE_SIZE;

            pt.x =
              s.x +
              s.width +
              (dx + this.horizontalOffset + this.tolerance + this.connectorImg.offsetWidth) / 2;
            pt.y = s.y + s.height / 2;
          }

          const alpha = mxUtils.toRadians(mxUtils.getValue(s.style, mxConstants.STYLE_ROTATION, 0));

          if (alpha != 0) {
            const cos = Math.cos(alpha);
            const sin = Math.sin(alpha);

            const ct = new mxPoint(s.getCenterX(), s.getCenterY());

            pt = mxUtils.getRotatedPoint(pt, cos, sin, ct);
          }

          this.connectorImg.style.left =
            Math.round(pt.x - this.connectorImg.offsetWidth / 2) + 'px';
          this.connectorImg.style.top =
            Math.round(pt.y - this.connectorImg.offsetHeight / 2) + 'px';
        }

        if (this.state != null && this.linkHint != null) {
          const c = new mxPoint(this.state.getCenterX(), this.state.getCenterY());
          const tmp = new mxRectangle(
            this.state.x,
            this.state.y - 22,
            this.state.width + 24,
            this.state.height + 22
          );
          let bb = mxUtils.getBoundingBox(
            tmp,
            this.state.style[mxConstants.STYLE_ROTATION] || '0',
            c
          );
          const rs =
            bb != null
              ? mxUtils.getBoundingBox(
                  this.state,
                  this.state.style[mxConstants.STYLE_ROTATION] || '0'
                )
              : this.state;

          if (bb == null) {
            bb = this.state;
          }

          this.linkHint.style.left =
            Math.round(rs.x + (rs.width - this.linkHint.clientWidth) / 2) + 'px';
          this.linkHint.style.top =
            Math.round(
              bb.y + bb.height + this.verticalOffset / 2 + 6 + this.state.view.graph.tolerance
            ) + 'px';
        }
      };

      const vertexHandlerSetHandlesVisible = mxVertexHandler.prototype.setHandlesVisible;

      mxVertexHandler.prototype.setHandlesVisible = function (visible) {
        vertexHandlerSetHandlesVisible.apply(this, arguments);

        if (this.connectorImg != null) {
          this.connectorImg.style.visibility = visible ? '' : 'hidden';
        }

        if (this.linkHint != null) {
          this.linkHint.style.visibility = visible ? '' : 'hidden';
        }
      };

      const vertexHandlerReset = mxVertexHandler.prototype.reset;

      mxVertexHandler.prototype.reset = function () {
        vertexHandlerReset.apply(this, arguments);

        if (this.connectorImg != null) {
          this.connectorImg.style.visibility = '';
        }

        if (this.linkHint != null) {
          this.linkHint.style.visibility = '';
        }
      };

      const vertexHandlerDestroy = mxVertexHandler.prototype.destroy;

      mxVertexHandler.prototype.destroy = function () {
        vertexHandlerDestroy.apply(this, arguments);
        const cell = this.state?.cell;

        if (isActivity(cell)) {
          cell.comp?.instance.toggleHighlight(false);
        }

        if (this.linkHint != null) {
          this.linkHint.parentNode.removeChild(this.linkHint);
          this.linkHint = null;
        }

        if (this.connectorImg != null) {
          this.connectorImg.parentNode.removeChild(this.connectorImg);
          this.connectorImg = null;
        }

        if (this.selectionHandler != null) {
          this.graph.getSelectionModel().removeListener(this.selectionHandler);
          this.selectionHandler = null;
        }

        if (this.changeHandler != null) {
          this.graph.getModel().removeListener(this.changeHandler);
          this.changeHandler = null;
        }
      };

      const edgeHandlerRedrawHandles = mxEdgeHandler.prototype.redrawHandles;

      mxEdgeHandler.prototype.redrawHandles = function () {
        // Workaround for special case where handler
        // is reset before this which leads to a NPE
        if (this.marker != null) {
          edgeHandlerRedrawHandles.apply(this);

          if (this.state != null && this.linkHint != null) {
            let b = this.state;

            if (this.state.text != null && this.state.text.bounds != null) {
              b = new mxRectangle(b.x, b.y, b.width, b.height);
              b.add(this.state.text.bounds);
            }

            this.linkHint.style.left =
              Math.round(b.x + (b.width - this.linkHint.clientWidth) / 2) + 'px';
            this.linkHint.style.top =
              Math.round(b.y + b.height + 6 + this.state.view.graph.tolerance) + 'px';
          }
        }
      };

      const edgeHandlerReset = mxEdgeHandler.prototype.reset;

      mxEdgeHandler.prototype.reset = function () {
        edgeHandlerReset.apply(this, arguments);

        if (this.linkHint != null) {
          this.linkHint.style.visibility = '';
        }
      };

      const edgeHandlerDestroy = mxEdgeHandler.prototype.destroy;

      mxEdgeHandler.prototype.destroy = function (sender, me) {
        edgeHandlerDestroy.apply(this, arguments);

        if (this.linkHint != null) {
          this.linkHint.parentNode.removeChild(this.linkHint);
          this.linkHint = null;
        }

        if (this.selectionHandler != null) {
          this.graph.getSelectionModel().removeListener(this.selectionHandler);
          this.selectionHandler = null;
        }

        if (this.changeHandler != null) {
          this.graph.getModel().removeListener(this.changeHandler);
          this.changeHandler = null;
        }
      };
    })();

    this.q9Graph = Graph;
  }
}
